import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
import * as dcei_wildsky_chest_proto from './dcei_wildsky_chest_proto';
export class GachaGroup {
  get descriptor() {
    return GachaGroup.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasPlayerLevelMin = false;
    this._playerLevelMin = null;
    this._hasPlayerLevelMax = false;
    this._playerLevelMax = null;
    this._chestTiers = [];
    this._refreshDays = [];
    this._refreshTime = [];
    this._hasMaxAdsPerDay = false;
    this._maxAdsPerDay = null;
    this._hasDisplayName = false;
    this._displayName = null;
    this._hasChestCloseImage = false;
    this._chestCloseImage = null;
    this._hasChestOpenImage = false;
    this._chestOpenImage = null;
    this._hasChestPrefab = false;
    this._chestPrefab = null;
    this._hasOneTime = false;
    this._oneTime = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasPlayerLevelMin) return false;
    if (this._hasPlayerLevelMax) return false;
    if (this._chestTiers.length > 0) return false;
    if (this._refreshDays.length > 0) return false;
    if (this._refreshTime.length > 0) return false;
    if (this._hasMaxAdsPerDay) return false;
    if (this._hasDisplayName) return false;
    if (this._hasChestCloseImage) return false;
    if (this._hasChestOpenImage) return false;
    if (this._hasChestPrefab) return false;
    if (this._hasOneTime) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof GachaGroup) {
      return value;
    }
    return GachaGroup.fromJson(value);
  }
  static fromJson(json) {
    const result = new GachaGroup();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.playerLevelMin != null) {
      result._hasPlayerLevelMin = true;
      result._playerLevelMin = JsonToInt32.fromJson(json.playerLevelMin);
    }
    if (json.playerLevelMax != null) {
      result._hasPlayerLevelMax = true;
      result._playerLevelMax = JsonToInt32.fromJson(json.playerLevelMax);
    }
    result._chestTiers = JsonToList(json.chestTiers, dcei_wildsky_chest_proto.Chest);
    result._refreshDays = JsonToList(json.refreshDays, JsonToString);
    result._refreshTime = JsonToList(json.refreshTime, JsonToInt32);
    if (json.maxAdsPerDay != null) {
      result._hasMaxAdsPerDay = true;
      result._maxAdsPerDay = JsonToInt32.fromJson(json.maxAdsPerDay);
    }
    if (json.displayName != null) {
      result._hasDisplayName = true;
      result._displayName = JsonToString.fromJson(json.displayName);
    }
    if (json.chestCloseImage != null) {
      result._hasChestCloseImage = true;
      result._chestCloseImage = JsonToString.fromJson(json.chestCloseImage);
    }
    if (json.chestOpenImage != null) {
      result._hasChestOpenImage = true;
      result._chestOpenImage = JsonToString.fromJson(json.chestOpenImage);
    }
    if (json.chestPrefab != null) {
      result._hasChestPrefab = true;
      result._chestPrefab = JsonToString.fromJson(json.chestPrefab);
    }
    if (json.oneTime != null) {
      result._hasOneTime = true;
      result._oneTime = JsonToBoolean.fromJson(json.oneTime);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasPlayerLevelMin) {
      result.playerLevelMin = JsonToInt32.toJson(this._playerLevelMin);
    }
    if (this._hasPlayerLevelMax) {
      result.playerLevelMax = JsonToInt32.toJson(this._playerLevelMax);
    }
    if (this._chestTiers.length > 0) {
      result.chestTiers = ArrayToJson(this._chestTiers, dcei_wildsky_chest_proto.Chest);
    }
    if (this._refreshDays.length > 0) {
      result.refreshDays = ArrayToJson(this._refreshDays, JsonToString);
    }
    if (this._refreshTime.length > 0) {
      result.refreshTime = ArrayToJson(this._refreshTime, JsonToInt32);
    }
    if (this._hasMaxAdsPerDay) {
      result.maxAdsPerDay = JsonToInt32.toJson(this._maxAdsPerDay);
    }
    if (this._hasDisplayName) {
      result.displayName = JsonToString.toJson(this._displayName);
    }
    if (this._hasChestCloseImage) {
      result.chestCloseImage = JsonToString.toJson(this._chestCloseImage);
    }
    if (this._hasChestOpenImage) {
      result.chestOpenImage = JsonToString.toJson(this._chestOpenImage);
    }
    if (this._hasChestPrefab) {
      result.chestPrefab = JsonToString.toJson(this._chestPrefab);
    }
    if (this._hasOneTime) {
      result.oneTime = JsonToBoolean.toJson(this._oneTime);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {number}
   */
  get playerLevelMin() {
    return this._hasPlayerLevelMin ? this._playerLevelMin : JsonToInt32.default;
  }
  get hasPlayerLevelMin() {
    return this._hasPlayerLevelMin;
  }
  setPlayerLevelMin(path, value) {
    return {type: 'SET', path: path.concat(['playerLevelMin']), value};
  }
  deletePlayerLevelMin(path) {
    return {type: 'DELETE', path: path.concat(['playerLevelMin'])};
  }
  /**
   * @returns {number}
   */
  get playerLevelMax() {
    return this._hasPlayerLevelMax ? this._playerLevelMax : JsonToInt32.default;
  }
  get hasPlayerLevelMax() {
    return this._hasPlayerLevelMax;
  }
  setPlayerLevelMax(path, value) {
    return {type: 'SET', path: path.concat(['playerLevelMax']), value};
  }
  deletePlayerLevelMax(path) {
    return {type: 'DELETE', path: path.concat(['playerLevelMax'])};
  }
  /**
   * @returns {dcei_wildsky_chest_proto.Chest[]}
   */
  get chestTiers() {
    return this._chestTiers;
  }
  addChestTiers(path, value) {
    return {type: 'ADD', path: path.concat(['chestTiers']), value: value.toJson()};
  }
  setChestTiers(path, value) {
    return {type: 'SET', path: path.concat(['chestTiers']), value: ArrayToJson(value, dcei_wildsky_chest_proto.Chest)};
  }
  setChestTiersByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['chestTiers', key]), value: value.toJson()};
  }
  deleteChestTiers(path) {
    return {type: 'DELETE', path: path.concat(['chestTiers'])};
  }
  deleteChestTiersByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['chestTiers', key])};
  }
  /**
   * @returns {string[]}
   */
  get refreshDays() {
    return this._refreshDays;
  }
  addRefreshDays(path, value) {
    return {type: 'ADD', path: path.concat(['refreshDays']), value};
  }
  setRefreshDays(path, value) {
    return {type: 'SET', path: path.concat(['refreshDays']), value: ArrayToJson(value, JsonToString)};
  }
  setRefreshDaysByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['refreshDays', key]), value};
  }
  deleteRefreshDays(path) {
    return {type: 'DELETE', path: path.concat(['refreshDays'])};
  }
  deleteRefreshDaysByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['refreshDays', key])};
  }
  /**
   * @returns {number[]}
   */
  get refreshTime() {
    return this._refreshTime;
  }
  addRefreshTime(path, value) {
    return {type: 'ADD', path: path.concat(['refreshTime']), value};
  }
  setRefreshTime(path, value) {
    return {type: 'SET', path: path.concat(['refreshTime']), value: ArrayToJson(value, JsonToInt32)};
  }
  setRefreshTimeByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['refreshTime', key]), value};
  }
  deleteRefreshTime(path) {
    return {type: 'DELETE', path: path.concat(['refreshTime'])};
  }
  deleteRefreshTimeByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['refreshTime', key])};
  }
  /**
   * @returns {number}
   */
  get maxAdsPerDay() {
    return this._hasMaxAdsPerDay ? this._maxAdsPerDay : JsonToInt32.default;
  }
  get hasMaxAdsPerDay() {
    return this._hasMaxAdsPerDay;
  }
  setMaxAdsPerDay(path, value) {
    return {type: 'SET', path: path.concat(['maxAdsPerDay']), value};
  }
  deleteMaxAdsPerDay(path) {
    return {type: 'DELETE', path: path.concat(['maxAdsPerDay'])};
  }
  /**
   * @returns {string}
   */
  get displayName() {
    return this._hasDisplayName ? this._displayName : JsonToString.default;
  }
  get hasDisplayName() {
    return this._hasDisplayName;
  }
  setDisplayName(path, value) {
    return {type: 'SET', path: path.concat(['displayName']), value};
  }
  deleteDisplayName(path) {
    return {type: 'DELETE', path: path.concat(['displayName'])};
  }
  /**
   * @returns {string}
   */
  get chestCloseImage() {
    return this._hasChestCloseImage ? this._chestCloseImage : JsonToString.default;
  }
  get hasChestCloseImage() {
    return this._hasChestCloseImage;
  }
  setChestCloseImage(path, value) {
    return {type: 'SET', path: path.concat(['chestCloseImage']), value};
  }
  deleteChestCloseImage(path) {
    return {type: 'DELETE', path: path.concat(['chestCloseImage'])};
  }
  /**
   * @returns {string}
   */
  get chestOpenImage() {
    return this._hasChestOpenImage ? this._chestOpenImage : JsonToString.default;
  }
  get hasChestOpenImage() {
    return this._hasChestOpenImage;
  }
  setChestOpenImage(path, value) {
    return {type: 'SET', path: path.concat(['chestOpenImage']), value};
  }
  deleteChestOpenImage(path) {
    return {type: 'DELETE', path: path.concat(['chestOpenImage'])};
  }
  /**
   * @returns {string}
   */
  get chestPrefab() {
    return this._hasChestPrefab ? this._chestPrefab : JsonToString.default;
  }
  get hasChestPrefab() {
    return this._hasChestPrefab;
  }
  setChestPrefab(path, value) {
    return {type: 'SET', path: path.concat(['chestPrefab']), value};
  }
  deleteChestPrefab(path) {
    return {type: 'DELETE', path: path.concat(['chestPrefab'])};
  }
  /**
   * @returns {boolean}
   */
  get oneTime() {
    return this._hasOneTime ? this._oneTime : JsonToBoolean.default;
  }
  get hasOneTime() {
    return this._hasOneTime;
  }
  setOneTime(path, value) {
    return {type: 'SET', path: path.concat(['oneTime']), value};
  }
  deleteOneTime(path) {
    return {type: 'DELETE', path: path.concat(['oneTime'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GachaGroup(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new GachaGroup(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "playerLevelMin": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GachaGroup(this);
              copy._hasPlayerLevelMin = true;
              copy._playerLevelMin = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPlayerLevelMin) {
                return this;
              }
              const copy = new GachaGroup(this);
              copy._hasPlayerLevelMin = false;
              copy._playerLevelMin = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "playerLevelMax": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GachaGroup(this);
              copy._hasPlayerLevelMax = true;
              copy._playerLevelMax = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPlayerLevelMax) {
                return this;
              }
              const copy = new GachaGroup(this);
              copy._hasPlayerLevelMax = false;
              copy._playerLevelMax = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "chestTiers": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GachaGroup(this);
              copy._chestTiers = [];        for (let i of value) {
                copy._chestTiers.push(dcei_wildsky_chest_proto.Chest.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new GachaGroup(this);
              copy._chestTiers = copy._chestTiers.concat([dcei_wildsky_chest_proto.Chest.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._chestTiers.length === 0) {
                return this;
              }
              const copy = new GachaGroup(this);
              copy._chestTiers = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._chestTiers.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new GachaGroup(this);
              copy._chestTiers = copy._chestTiers.slice();
              copy._chestTiers[path[1]] = dcei_wildsky_chest_proto.Chest.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new GachaGroup(this);
              copy._chestTiers = copy._chestTiers.slice(0, path[1]).concat(copy._chestTiers.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._chestTiers.length) {
            return this;
          }
          const oldValue = this._chestTiers[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new GachaGroup(this);
          copy._chestTiers = copy._chestTiers.slice();
          copy._chestTiers[key] = newValue;
          return copy;
        }
      }
      case "refreshDays": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GachaGroup(this);
              copy._refreshDays = [];        for (let i of value) {
                copy._refreshDays.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new GachaGroup(this);
              copy._refreshDays = copy._refreshDays.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._refreshDays.length === 0) {
                return this;
              }
              const copy = new GachaGroup(this);
              copy._refreshDays = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._refreshDays.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new GachaGroup(this);
              copy._refreshDays = copy._refreshDays.slice();
              copy._refreshDays[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new GachaGroup(this);
              copy._refreshDays = copy._refreshDays.slice(0, path[1]).concat(copy._refreshDays.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._refreshDays.length) {
            return this;
          }
          const oldValue = this._refreshDays[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new GachaGroup(this);
          copy._refreshDays = copy._refreshDays.slice();
          copy._refreshDays[key] = newValue;
          return copy;
        }
      }
      case "refreshTime": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GachaGroup(this);
              copy._refreshTime = [];        for (let i of value) {
                copy._refreshTime.push(JsonToInt32.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new GachaGroup(this);
              copy._refreshTime = copy._refreshTime.concat([JsonToInt32.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._refreshTime.length === 0) {
                return this;
              }
              const copy = new GachaGroup(this);
              copy._refreshTime = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._refreshTime.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new GachaGroup(this);
              copy._refreshTime = copy._refreshTime.slice();
              copy._refreshTime[path[1]] = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new GachaGroup(this);
              copy._refreshTime = copy._refreshTime.slice(0, path[1]).concat(copy._refreshTime.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._refreshTime.length) {
            return this;
          }
          const oldValue = this._refreshTime[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new GachaGroup(this);
          copy._refreshTime = copy._refreshTime.slice();
          copy._refreshTime[key] = newValue;
          return copy;
        }
      }
      case "maxAdsPerDay": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GachaGroup(this);
              copy._hasMaxAdsPerDay = true;
              copy._maxAdsPerDay = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMaxAdsPerDay) {
                return this;
              }
              const copy = new GachaGroup(this);
              copy._hasMaxAdsPerDay = false;
              copy._maxAdsPerDay = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "displayName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GachaGroup(this);
              copy._hasDisplayName = true;
              copy._displayName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayName) {
                return this;
              }
              const copy = new GachaGroup(this);
              copy._hasDisplayName = false;
              copy._displayName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "chestCloseImage": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GachaGroup(this);
              copy._hasChestCloseImage = true;
              copy._chestCloseImage = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasChestCloseImage) {
                return this;
              }
              const copy = new GachaGroup(this);
              copy._hasChestCloseImage = false;
              copy._chestCloseImage = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "chestOpenImage": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GachaGroup(this);
              copy._hasChestOpenImage = true;
              copy._chestOpenImage = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasChestOpenImage) {
                return this;
              }
              const copy = new GachaGroup(this);
              copy._hasChestOpenImage = false;
              copy._chestOpenImage = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "chestPrefab": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GachaGroup(this);
              copy._hasChestPrefab = true;
              copy._chestPrefab = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasChestPrefab) {
                return this;
              }
              const copy = new GachaGroup(this);
              copy._hasChestPrefab = false;
              copy._chestPrefab = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "oneTime": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GachaGroup(this);
              copy._hasOneTime = true;
              copy._oneTime = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOneTime) {
                return this;
              }
              const copy = new GachaGroup(this);
              copy._hasOneTime = false;
              copy._oneTime = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {GachaGroup} other
   * @returns {GachaGroup}
   */
  merge(other) {
    const copy = new GachaGroup(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasPlayerLevelMin) {
      copy._hasPlayerLevelMin = true;
      copy._playerLevelMin = other._playerLevelMin;
    }
    if (other._hasPlayerLevelMax) {
      copy._hasPlayerLevelMax = true;
      copy._playerLevelMax = other._playerLevelMax;
    }
    copy._chestTiers = this._chestTiers.concat(other._chestTiers);
    copy._refreshDays = this._refreshDays.concat(other._refreshDays);
    copy._refreshTime = this._refreshTime.concat(other._refreshTime);
    if (other._hasMaxAdsPerDay) {
      copy._hasMaxAdsPerDay = true;
      copy._maxAdsPerDay = other._maxAdsPerDay;
    }
    if (other._hasDisplayName) {
      copy._hasDisplayName = true;
      copy._displayName = other._displayName;
    }
    if (other._hasChestCloseImage) {
      copy._hasChestCloseImage = true;
      copy._chestCloseImage = other._chestCloseImage;
    }
    if (other._hasChestOpenImage) {
      copy._hasChestOpenImage = true;
      copy._chestOpenImage = other._chestOpenImage;
    }
    if (other._hasChestPrefab) {
      copy._hasChestPrefab = true;
      copy._chestPrefab = other._chestPrefab;
    }
    if (other._hasOneTime) {
      copy._hasOneTime = true;
      copy._oneTime = other._oneTime;
    }
    return copy;
  }
}
GachaGroup.default = new GachaGroup();
class GachaGroup_Builder {
  constructor(value) {
    this._value = new GachaGroup(value);
  }
  build() {
    return new GachaGroup(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setPlayerLevelMin(value) {
    this._value._hasPlayerLevelMin = true;
    this._value._playerLevelMin = value;
    return this;
  }
  deletePlayerLevelMin() {
    this._value._hasPlayerLevelMin = false;
    this._value._playerLevelMin = null;
    return this;
  }
  setPlayerLevelMax(value) {
    this._value._hasPlayerLevelMax = true;
    this._value._playerLevelMax = value;
    return this;
  }
  deletePlayerLevelMax() {
    this._value._hasPlayerLevelMax = false;
    this._value._playerLevelMax = null;
    return this;
  }
  addAllChestTiers(values) {
    this._value._chestTiers = this._value._chestTiers.concat(values);
    return this;
  }
  addChestTiers(value) {
    this._value._chestTiers = this._value._chestTiers.concat([value]);
    return this;
  }
  setChestTiers(index, value) {
    this._value._chestTiers = this._value._chestTiers.concat();
    this._value._chestTiers[index] = value;
    return this;
  }
  clearChestTiers() {
    this._value._chestTiers = [];
    return this;
  }
  addAllRefreshDays(values) {
    this._value._refreshDays = this._value._refreshDays.concat(values);
    return this;
  }
  addRefreshDays(value) {
    this._value._refreshDays = this._value._refreshDays.concat([value]);
    return this;
  }
  setRefreshDays(index, value) {
    this._value._refreshDays = this._value._refreshDays.concat();
    this._value._refreshDays[index] = value;
    return this;
  }
  clearRefreshDays() {
    this._value._refreshDays = [];
    return this;
  }
  addAllRefreshTime(values) {
    this._value._refreshTime = this._value._refreshTime.concat(values);
    return this;
  }
  addRefreshTime(value) {
    this._value._refreshTime = this._value._refreshTime.concat([value]);
    return this;
  }
  setRefreshTime(index, value) {
    this._value._refreshTime = this._value._refreshTime.concat();
    this._value._refreshTime[index] = value;
    return this;
  }
  clearRefreshTime() {
    this._value._refreshTime = [];
    return this;
  }
  setMaxAdsPerDay(value) {
    this._value._hasMaxAdsPerDay = true;
    this._value._maxAdsPerDay = value;
    return this;
  }
  deleteMaxAdsPerDay() {
    this._value._hasMaxAdsPerDay = false;
    this._value._maxAdsPerDay = null;
    return this;
  }
  setDisplayName(value) {
    this._value._hasDisplayName = true;
    this._value._displayName = value;
    return this;
  }
  deleteDisplayName() {
    this._value._hasDisplayName = false;
    this._value._displayName = null;
    return this;
  }
  setChestCloseImage(value) {
    this._value._hasChestCloseImage = true;
    this._value._chestCloseImage = value;
    return this;
  }
  deleteChestCloseImage() {
    this._value._hasChestCloseImage = false;
    this._value._chestCloseImage = null;
    return this;
  }
  setChestOpenImage(value) {
    this._value._hasChestOpenImage = true;
    this._value._chestOpenImage = value;
    return this;
  }
  deleteChestOpenImage() {
    this._value._hasChestOpenImage = false;
    this._value._chestOpenImage = null;
    return this;
  }
  setChestPrefab(value) {
    this._value._hasChestPrefab = true;
    this._value._chestPrefab = value;
    return this;
  }
  deleteChestPrefab() {
    this._value._hasChestPrefab = false;
    this._value._chestPrefab = null;
    return this;
  }
  setOneTime(value) {
    this._value._hasOneTime = true;
    this._value._oneTime = value;
    return this;
  }
  deleteOneTime() {
    this._value._hasOneTime = false;
    this._value._oneTime = null;
    return this;
  }
}
GachaGroup.Builder = GachaGroup_Builder;
class GachaGroup_WithParent {
  /**
   * @param {GachaGroup} value
   * @param {GachaGroup_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return GachaGroup.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasPlayerLevelMin() {
    if (this._cachedHasPlayerLevelMin === undefined) {
      if (this._value.hasPlayerLevelMin) {
        this._cachedHasPlayerLevelMin = true;
      } else {
        this._cachedHasPlayerLevelMin = this._parent ? this._parent.hasPlayerLevelMin : false;
      }
    }
    return this._cachedHasPlayerLevelMin;
  }
  get playerLevelMin() {
    if (this._cachedPlayerLevelMin === undefined) {
      if (this._value.hasPlayerLevelMin) {
        this._cachedPlayerLevelMin = this._value.playerLevelMin;
      } else {
        this._cachedPlayerLevelMin = this._parent ? this._parent.playerLevelMin : this._value.playerLevelMin;
      }
    }
    return this._cachedPlayerLevelMin;
  }
  get hasPlayerLevelMax() {
    if (this._cachedHasPlayerLevelMax === undefined) {
      if (this._value.hasPlayerLevelMax) {
        this._cachedHasPlayerLevelMax = true;
      } else {
        this._cachedHasPlayerLevelMax = this._parent ? this._parent.hasPlayerLevelMax : false;
      }
    }
    return this._cachedHasPlayerLevelMax;
  }
  get playerLevelMax() {
    if (this._cachedPlayerLevelMax === undefined) {
      if (this._value.hasPlayerLevelMax) {
        this._cachedPlayerLevelMax = this._value.playerLevelMax;
      } else {
        this._cachedPlayerLevelMax = this._parent ? this._parent.playerLevelMax : this._value.playerLevelMax;
      }
    }
    return this._cachedPlayerLevelMax;
  }
  get selfChestTiers() {
    if (!this._selfChestTiers) {
      this._selfChestTiers = [];
      for (let i of this._value.chestTiers) {
        this._selfChestTiers.push(new dcei_wildsky_chest_proto.Chest.WithParent(i, null));
      }
    }
    return this._selfChestTiers;
  }
  get inherentChestTiers() {
    if (!this._inherentChestTiers) {
      this._inherentChestTiers = this._parent ? this._parent.chestTiers : [];
    }
    return this._inherentChestTiers;
  }
  get chestTiers() {
    if (!this._allChestTiers) {
      this._allChestTiers = this._parent ? this._parent.chestTiers.concat(this.selfChestTiers) : this.selfChestTiers;
    }
    return this._allChestTiers;
  }
  get selfRefreshDays() {
    return this._value.refreshDays;
  }
  get inherentRefreshDays() {
    if (!this._inherentRefreshDays) {
      this._inherentRefreshDays = this._parent ? this._parent.refreshDays : [];
    }
    return this._inherentRefreshDays;
  }
  get refreshDays() {
    if (!this._allRefreshDays) {
      this._allRefreshDays = this._parent ? this._parent.refreshDays.concat(this.selfRefreshDays) : this.selfRefreshDays;
    }
    return this._allRefreshDays;
  }
  get selfRefreshTime() {
    return this._value.refreshTime;
  }
  get inherentRefreshTime() {
    if (!this._inherentRefreshTime) {
      this._inherentRefreshTime = this._parent ? this._parent.refreshTime : [];
    }
    return this._inherentRefreshTime;
  }
  get refreshTime() {
    if (!this._allRefreshTime) {
      this._allRefreshTime = this._parent ? this._parent.refreshTime.concat(this.selfRefreshTime) : this.selfRefreshTime;
    }
    return this._allRefreshTime;
  }
  get hasMaxAdsPerDay() {
    if (this._cachedHasMaxAdsPerDay === undefined) {
      if (this._value.hasMaxAdsPerDay) {
        this._cachedHasMaxAdsPerDay = true;
      } else {
        this._cachedHasMaxAdsPerDay = this._parent ? this._parent.hasMaxAdsPerDay : false;
      }
    }
    return this._cachedHasMaxAdsPerDay;
  }
  get maxAdsPerDay() {
    if (this._cachedMaxAdsPerDay === undefined) {
      if (this._value.hasMaxAdsPerDay) {
        this._cachedMaxAdsPerDay = this._value.maxAdsPerDay;
      } else {
        this._cachedMaxAdsPerDay = this._parent ? this._parent.maxAdsPerDay : this._value.maxAdsPerDay;
      }
    }
    return this._cachedMaxAdsPerDay;
  }
  get hasDisplayName() {
    if (this._cachedHasDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedHasDisplayName = true;
      } else {
        this._cachedHasDisplayName = this._parent ? this._parent.hasDisplayName : false;
      }
    }
    return this._cachedHasDisplayName;
  }
  get displayName() {
    if (this._cachedDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedDisplayName = this._value.displayName;
      } else {
        this._cachedDisplayName = this._parent ? this._parent.displayName : this._value.displayName;
      }
    }
    return this._cachedDisplayName;
  }
  get hasChestCloseImage() {
    if (this._cachedHasChestCloseImage === undefined) {
      if (this._value.hasChestCloseImage) {
        this._cachedHasChestCloseImage = true;
      } else {
        this._cachedHasChestCloseImage = this._parent ? this._parent.hasChestCloseImage : false;
      }
    }
    return this._cachedHasChestCloseImage;
  }
  get chestCloseImage() {
    if (this._cachedChestCloseImage === undefined) {
      if (this._value.hasChestCloseImage) {
        this._cachedChestCloseImage = this._value.chestCloseImage;
      } else {
        this._cachedChestCloseImage = this._parent ? this._parent.chestCloseImage : this._value.chestCloseImage;
      }
    }
    return this._cachedChestCloseImage;
  }
  get hasChestOpenImage() {
    if (this._cachedHasChestOpenImage === undefined) {
      if (this._value.hasChestOpenImage) {
        this._cachedHasChestOpenImage = true;
      } else {
        this._cachedHasChestOpenImage = this._parent ? this._parent.hasChestOpenImage : false;
      }
    }
    return this._cachedHasChestOpenImage;
  }
  get chestOpenImage() {
    if (this._cachedChestOpenImage === undefined) {
      if (this._value.hasChestOpenImage) {
        this._cachedChestOpenImage = this._value.chestOpenImage;
      } else {
        this._cachedChestOpenImage = this._parent ? this._parent.chestOpenImage : this._value.chestOpenImage;
      }
    }
    return this._cachedChestOpenImage;
  }
  get hasChestPrefab() {
    if (this._cachedHasChestPrefab === undefined) {
      if (this._value.hasChestPrefab) {
        this._cachedHasChestPrefab = true;
      } else {
        this._cachedHasChestPrefab = this._parent ? this._parent.hasChestPrefab : false;
      }
    }
    return this._cachedHasChestPrefab;
  }
  get chestPrefab() {
    if (this._cachedChestPrefab === undefined) {
      if (this._value.hasChestPrefab) {
        this._cachedChestPrefab = this._value.chestPrefab;
      } else {
        this._cachedChestPrefab = this._parent ? this._parent.chestPrefab : this._value.chestPrefab;
      }
    }
    return this._cachedChestPrefab;
  }
  get hasOneTime() {
    if (this._cachedHasOneTime === undefined) {
      if (this._value.hasOneTime) {
        this._cachedHasOneTime = true;
      } else {
        this._cachedHasOneTime = this._parent ? this._parent.hasOneTime : false;
      }
    }
    return this._cachedHasOneTime;
  }
  get oneTime() {
    if (this._cachedOneTime === undefined) {
      if (this._value.hasOneTime) {
        this._cachedOneTime = this._value.oneTime;
      } else {
        this._cachedOneTime = this._parent ? this._parent.oneTime : this._value.oneTime;
      }
    }
    return this._cachedOneTime;
  }
  update(current, parent) {
    const result = new GachaGroup_WithParent(current, parent);
    if (this._selfChestTiers) {
      if (this._value.chestTiers === current.chestTiers) {
        result._selfChestTiers = this._selfChestTiers;
      } else {
        result._selfChestTiers = [];
        for (let i = 0; i < current.chestTiers.length; i++) {
          const oldValue = this._value.chestTiers[i];
          if (oldValue) {
            const oldCache = this._selfChestTiers[i];
            if (oldValue === current.chestTiers[i]) {
              result._selfChestTiers[i] = oldCache;
            } else {
              result._selfChestTiers[i] = oldCache.update(current.chestTiers[i], null);
            }
          } else {
            result._selfChestTiers[i] = new dcei_wildsky_chest_proto.Chest.WithParent(current.chestTiers[i], null);
          }
        }
      }
    }
    return result;
  }
}
GachaGroup_WithParent.default = new GachaGroup_WithParent(GachaGroup.default, null);
GachaGroup.WithParent = GachaGroup_WithParent;
class GachaGroup_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get playerLevelMin() {
    if (!this._playerLevelMin) {
      this._playerLevelMin = {
        name: "playerLevelMin",
        Name: "PlayerLevelMin",
        number: 6,
        protoType: 5,
        protoName: "player_level_min",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playerLevelMin;
  }
  get playerLevelMax() {
    if (!this._playerLevelMax) {
      this._playerLevelMax = {
        name: "playerLevelMax",
        Name: "PlayerLevelMax",
        number: 7,
        protoType: 5,
        protoName: "player_level_max",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playerLevelMax;
  }
  get chestTiers() {
    if (!this._chestTiers) {
      this._chestTiers = {
        name: "chestTiers",
        Name: "ChestTiers",
        number: 2,
        protoType: 11,
        protoName: "chest_tiers",
        type: dcei_wildsky_chest_proto.Chest,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chestTiers;
  }
  get refreshDays() {
    if (!this._refreshDays) {
      this._refreshDays = {
        name: "refreshDays",
        Name: "RefreshDays",
        number: 3,
        protoType: 9,
        protoName: "refresh_days",
        type: JsonToString,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._refreshDays;
  }
  get refreshTime() {
    if (!this._refreshTime) {
      this._refreshTime = {
        name: "refreshTime",
        Name: "RefreshTime",
        number: 4,
        protoType: 5,
        protoName: "refresh_time",
        type: JsonToInt32,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._refreshTime;
  }
  get maxAdsPerDay() {
    if (!this._maxAdsPerDay) {
      this._maxAdsPerDay = {
        name: "maxAdsPerDay",
        Name: "MaxAdsPerDay",
        number: 5,
        protoType: 5,
        protoName: "max_ads_per_day",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._maxAdsPerDay;
  }
  get displayName() {
    if (!this._displayName) {
      this._displayName = {
        name: "displayName",
        Name: "DisplayName",
        number: 51,
        protoType: 9,
        protoName: "display_name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayName;
  }
  get chestCloseImage() {
    if (!this._chestCloseImage) {
      this._chestCloseImage = {
        name: "chestCloseImage",
        Name: "ChestCloseImage",
        number: 52,
        protoType: 9,
        protoName: "chest_close_image",
        type: JsonToString,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chestCloseImage;
  }
  get chestOpenImage() {
    if (!this._chestOpenImage) {
      this._chestOpenImage = {
        name: "chestOpenImage",
        Name: "ChestOpenImage",
        number: 53,
        protoType: 9,
        protoName: "chest_open_image",
        type: JsonToString,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chestOpenImage;
  }
  get chestPrefab() {
    if (!this._chestPrefab) {
      this._chestPrefab = {
        name: "chestPrefab",
        Name: "ChestPrefab",
        number: 54,
        protoType: 9,
        protoName: "chest_prefab",
        type: JsonToString,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chestPrefab;
  }
  get oneTime() {
    if (!this._oneTime) {
      this._oneTime = {
        name: "oneTime",
        Name: "OneTime",
        number: 56,
        protoType: 8,
        protoName: "one_time",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._oneTime;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.playerLevelMin,
        this.playerLevelMax,
        this.chestTiers,
        this.refreshDays,
        this.refreshTime,
        this.maxAdsPerDay,
        this.displayName,
        this.chestCloseImage,
        this.chestOpenImage,
        this.chestPrefab,
        this.oneTime,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPlayerLevelMin",
        Name: "DummyOneofForPlayerLevelMin",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPlayerLevelMax",
        Name: "DummyOneofForPlayerLevelMax",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMaxAdsPerDay",
        Name: "DummyOneofForMaxAdsPerDay",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplayName",
        Name: "DummyOneofForDisplayName",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForChestCloseImage",
        Name: "DummyOneofForChestCloseImage",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForChestOpenImage",
        Name: "DummyOneofForChestOpenImage",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForChestPrefab",
        Name: "DummyOneofForChestPrefab",
        fields: [
          this.fields[10],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForOneTime",
        Name: "DummyOneofForOneTime",
        fields: [
          this.fields[11],
        ],
      });
    }
    return this._oneofs;
  }
}
GachaGroup.descriptor = new GachaGroup_Descriptor();
class PromotionalGachaGroup_CampaignLevelTrigger {
  get descriptor() {
    return PromotionalGachaGroup_CampaignLevelTrigger.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasWorldIndex = false;
    this._worldIndex = null;
    this._hasLevelIndex = false;
    this._levelIndex = null;
  }
  isEmpty() {
    if (this._hasWorldIndex) return false;
    if (this._hasLevelIndex) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof PromotionalGachaGroup_CampaignLevelTrigger) {
      return value;
    }
    return PromotionalGachaGroup_CampaignLevelTrigger.fromJson(value);
  }
  static fromJson(json) {
    const result = new PromotionalGachaGroup_CampaignLevelTrigger();
    if (json.worldIndex != null) {
      result._hasWorldIndex = true;
      result._worldIndex = JsonToInt32.fromJson(json.worldIndex);
    }
    if (json.levelIndex != null) {
      result._hasLevelIndex = true;
      result._levelIndex = JsonToInt32.fromJson(json.levelIndex);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasWorldIndex) {
      result.worldIndex = JsonToInt32.toJson(this._worldIndex);
    }
    if (this._hasLevelIndex) {
      result.levelIndex = JsonToInt32.toJson(this._levelIndex);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get worldIndex() {
    return this._hasWorldIndex ? this._worldIndex : JsonToInt32.default;
  }
  get hasWorldIndex() {
    return this._hasWorldIndex;
  }
  setWorldIndex(path, value) {
    return {type: 'SET', path: path.concat(['worldIndex']), value};
  }
  deleteWorldIndex(path) {
    return {type: 'DELETE', path: path.concat(['worldIndex'])};
  }
  /**
   * @returns {number}
   */
  get levelIndex() {
    return this._hasLevelIndex ? this._levelIndex : JsonToInt32.default;
  }
  get hasLevelIndex() {
    return this._hasLevelIndex;
  }
  setLevelIndex(path, value) {
    return {type: 'SET', path: path.concat(['levelIndex']), value};
  }
  deleteLevelIndex(path) {
    return {type: 'DELETE', path: path.concat(['levelIndex'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "worldIndex": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionalGachaGroup_CampaignLevelTrigger(this);
              copy._hasWorldIndex = true;
              copy._worldIndex = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWorldIndex) {
                return this;
              }
              const copy = new PromotionalGachaGroup_CampaignLevelTrigger(this);
              copy._hasWorldIndex = false;
              copy._worldIndex = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "levelIndex": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionalGachaGroup_CampaignLevelTrigger(this);
              copy._hasLevelIndex = true;
              copy._levelIndex = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLevelIndex) {
                return this;
              }
              const copy = new PromotionalGachaGroup_CampaignLevelTrigger(this);
              copy._hasLevelIndex = false;
              copy._levelIndex = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {PromotionalGachaGroup_CampaignLevelTrigger} other
   * @returns {PromotionalGachaGroup_CampaignLevelTrigger}
   */
  merge(other) {
    const copy = new PromotionalGachaGroup_CampaignLevelTrigger(this);
    if (other._hasWorldIndex) {
      copy._hasWorldIndex = true;
      copy._worldIndex = other._worldIndex;
    }
    if (other._hasLevelIndex) {
      copy._hasLevelIndex = true;
      copy._levelIndex = other._levelIndex;
    }
    return copy;
  }
}
PromotionalGachaGroup_CampaignLevelTrigger.default = new PromotionalGachaGroup_CampaignLevelTrigger();
class PromotionalGachaGroup_CampaignLevelTrigger_Builder {
  constructor(value) {
    this._value = new PromotionalGachaGroup_CampaignLevelTrigger(value);
  }
  build() {
    return new PromotionalGachaGroup_CampaignLevelTrigger(this._value);
  }
  setWorldIndex(value) {
    this._value._hasWorldIndex = true;
    this._value._worldIndex = value;
    return this;
  }
  deleteWorldIndex() {
    this._value._hasWorldIndex = false;
    this._value._worldIndex = null;
    return this;
  }
  setLevelIndex(value) {
    this._value._hasLevelIndex = true;
    this._value._levelIndex = value;
    return this;
  }
  deleteLevelIndex() {
    this._value._hasLevelIndex = false;
    this._value._levelIndex = null;
    return this;
  }
}
PromotionalGachaGroup_CampaignLevelTrigger.Builder = PromotionalGachaGroup_CampaignLevelTrigger_Builder;
class PromotionalGachaGroup_CampaignLevelTrigger_WithParent {
  /**
   * @param {PromotionalGachaGroup_CampaignLevelTrigger} value
   * @param {PromotionalGachaGroup_CampaignLevelTrigger_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return PromotionalGachaGroup_CampaignLevelTrigger.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasWorldIndex() {
    if (this._cachedHasWorldIndex === undefined) {
      if (this._value.hasWorldIndex) {
        this._cachedHasWorldIndex = true;
      } else {
        this._cachedHasWorldIndex = this._parent ? this._parent.hasWorldIndex : false;
      }
    }
    return this._cachedHasWorldIndex;
  }
  get worldIndex() {
    if (this._cachedWorldIndex === undefined) {
      if (this._value.hasWorldIndex) {
        this._cachedWorldIndex = this._value.worldIndex;
      } else {
        this._cachedWorldIndex = this._parent ? this._parent.worldIndex : this._value.worldIndex;
      }
    }
    return this._cachedWorldIndex;
  }
  get hasLevelIndex() {
    if (this._cachedHasLevelIndex === undefined) {
      if (this._value.hasLevelIndex) {
        this._cachedHasLevelIndex = true;
      } else {
        this._cachedHasLevelIndex = this._parent ? this._parent.hasLevelIndex : false;
      }
    }
    return this._cachedHasLevelIndex;
  }
  get levelIndex() {
    if (this._cachedLevelIndex === undefined) {
      if (this._value.hasLevelIndex) {
        this._cachedLevelIndex = this._value.levelIndex;
      } else {
        this._cachedLevelIndex = this._parent ? this._parent.levelIndex : this._value.levelIndex;
      }
    }
    return this._cachedLevelIndex;
  }
  update(current, parent) {
    const result = new PromotionalGachaGroup_CampaignLevelTrigger_WithParent(current, parent);
    return result;
  }
}
PromotionalGachaGroup_CampaignLevelTrigger_WithParent.default = new PromotionalGachaGroup_CampaignLevelTrigger_WithParent(PromotionalGachaGroup_CampaignLevelTrigger.default, null);
PromotionalGachaGroup_CampaignLevelTrigger.WithParent = PromotionalGachaGroup_CampaignLevelTrigger_WithParent;
class PromotionalGachaGroup_CampaignLevelTrigger_Descriptor {
  get worldIndex() {
    if (!this._worldIndex) {
      this._worldIndex = {
        name: "worldIndex",
        Name: "WorldIndex",
        number: 1,
        protoType: 5,
        protoName: "world_index",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._worldIndex;
  }
  get levelIndex() {
    if (!this._levelIndex) {
      this._levelIndex = {
        name: "levelIndex",
        Name: "LevelIndex",
        number: 2,
        protoType: 5,
        protoName: "level_index",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._levelIndex;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.worldIndex,
        this.levelIndex,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForWorldIndex",
        Name: "DummyOneofForWorldIndex",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLevelIndex",
        Name: "DummyOneofForLevelIndex",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
PromotionalGachaGroup_CampaignLevelTrigger.descriptor = new PromotionalGachaGroup_CampaignLevelTrigger_Descriptor();
export class PromotionalGachaGroup {
  get descriptor() {
    return PromotionalGachaGroup.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasExpireTimeInSeconds = false;
    this._expireTimeInSeconds = null;
    this._hasChest = false;
    this._chest = null;
    this._hasCampaignLevelTrigger = false;
    this._campaignLevelTrigger = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasExpireTimeInSeconds) return false;
    if (this._hasChest && !this._chest.isEmpty()) return false;
    if (this._hasCampaignLevelTrigger && !this._campaignLevelTrigger.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof PromotionalGachaGroup) {
      return value;
    }
    return PromotionalGachaGroup.fromJson(value);
  }
  static fromJson(json) {
    const result = new PromotionalGachaGroup();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.expireTimeInSeconds != null) {
      result._hasExpireTimeInSeconds = true;
      result._expireTimeInSeconds = JsonToInt32.fromJson(json.expireTimeInSeconds);
    }
    if (json.chest != null) {
      result._hasChest = true;
      result._chest = dcei_wildsky_chest_proto.Chest.fromJson(json.chest);
    }
    if (json.campaignLevelTrigger != null) {
      result._hasCampaignLevelTrigger = true;
      result._campaignLevelTrigger = PromotionalGachaGroup_CampaignLevelTrigger.fromJson(json.campaignLevelTrigger);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasExpireTimeInSeconds) {
      result.expireTimeInSeconds = JsonToInt32.toJson(this._expireTimeInSeconds);
    }
    if (this._hasChest && !this._chest.isEmpty()) {
      result.chest = dcei_wildsky_chest_proto.Chest.toJson(this._chest);
    }
    if (this._hasCampaignLevelTrigger && !this._campaignLevelTrigger.isEmpty()) {
      result.campaignLevelTrigger = PromotionalGachaGroup_CampaignLevelTrigger.toJson(this._campaignLevelTrigger);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {number}
   */
  get expireTimeInSeconds() {
    return this._hasExpireTimeInSeconds ? this._expireTimeInSeconds : JsonToInt32.default;
  }
  get hasExpireTimeInSeconds() {
    return this._hasExpireTimeInSeconds;
  }
  setExpireTimeInSeconds(path, value) {
    return {type: 'SET', path: path.concat(['expireTimeInSeconds']), value};
  }
  deleteExpireTimeInSeconds(path) {
    return {type: 'DELETE', path: path.concat(['expireTimeInSeconds'])};
  }
  /**
   * @returns {dcei_wildsky_chest_proto.Chest}
   */
  get chest() {
    return this._hasChest ? this._chest : dcei_wildsky_chest_proto.Chest.default;
  }
  get hasChest() {
    return this._hasChest;
  }
  setChest(path, value) {
    return {type: 'SET', path: path.concat(['chest']), value: value.toJson()};
  }
  deleteChest(path) {
    return {type: 'DELETE', path: path.concat(['chest'])};
  }
  /**
   * @returns {PromotionalGachaGroup_CampaignLevelTrigger}
   */
  get campaignLevelTrigger() {
    return this._hasCampaignLevelTrigger ? this._campaignLevelTrigger : PromotionalGachaGroup_CampaignLevelTrigger.default;
  }
  get hasCampaignLevelTrigger() {
    return this._hasCampaignLevelTrigger;
  }
  setCampaignLevelTrigger(path, value) {
    return {type: 'SET', path: path.concat(['campaignLevelTrigger']), value: value.toJson()};
  }
  deleteCampaignLevelTrigger(path) {
    return {type: 'DELETE', path: path.concat(['campaignLevelTrigger'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionalGachaGroup(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new PromotionalGachaGroup(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "expireTimeInSeconds": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionalGachaGroup(this);
              copy._hasExpireTimeInSeconds = true;
              copy._expireTimeInSeconds = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasExpireTimeInSeconds) {
                return this;
              }
              const copy = new PromotionalGachaGroup(this);
              copy._hasExpireTimeInSeconds = false;
              copy._expireTimeInSeconds = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "chest": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionalGachaGroup(this);
              copy._hasChest = true;
              copy._chest = dcei_wildsky_chest_proto.Chest.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasChest) {
                return this;
              }
              const copy = new PromotionalGachaGroup(this);
              copy._hasChest = false;
              copy._chest = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasChest) {
            const copy = new PromotionalGachaGroup(this);
            copy._hasChest = true;
            copy._chest = dcei_wildsky_chest_proto.Chest.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._chest.apply(type, path.slice(1), value);
          if (newValue === this._chest) {
            return this;
          }
          const copy = new PromotionalGachaGroup(this);
          copy._chest = copy._chest.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "campaignLevelTrigger": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionalGachaGroup(this);
              copy._hasCampaignLevelTrigger = true;
              copy._campaignLevelTrigger = PromotionalGachaGroup_CampaignLevelTrigger.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCampaignLevelTrigger) {
                return this;
              }
              const copy = new PromotionalGachaGroup(this);
              copy._hasCampaignLevelTrigger = false;
              copy._campaignLevelTrigger = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasCampaignLevelTrigger) {
            const copy = new PromotionalGachaGroup(this);
            copy._hasCampaignLevelTrigger = true;
            copy._campaignLevelTrigger = PromotionalGachaGroup_CampaignLevelTrigger.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._campaignLevelTrigger.apply(type, path.slice(1), value);
          if (newValue === this._campaignLevelTrigger) {
            return this;
          }
          const copy = new PromotionalGachaGroup(this);
          copy._campaignLevelTrigger = copy._campaignLevelTrigger.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {PromotionalGachaGroup} other
   * @returns {PromotionalGachaGroup}
   */
  merge(other) {
    const copy = new PromotionalGachaGroup(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasExpireTimeInSeconds) {
      copy._hasExpireTimeInSeconds = true;
      copy._expireTimeInSeconds = other._expireTimeInSeconds;
    }
    if (other._hasChest) {
      if (copy._hasChest) {
        copy._chest = copy.chest.merge(other.chest);
      } else {
        copy._chest = other._chest;
      }
      copy._hasChest = true;
    }
    if (other._hasCampaignLevelTrigger) {
      if (copy._hasCampaignLevelTrigger) {
        copy._campaignLevelTrigger = copy.campaignLevelTrigger.merge(other.campaignLevelTrigger);
      } else {
        copy._campaignLevelTrigger = other._campaignLevelTrigger;
      }
      copy._hasCampaignLevelTrigger = true;
    }
    return copy;
  }
}
PromotionalGachaGroup.default = new PromotionalGachaGroup();
PromotionalGachaGroup.CampaignLevelTrigger = PromotionalGachaGroup_CampaignLevelTrigger;
class PromotionalGachaGroup_Builder {
  constructor(value) {
    this._value = new PromotionalGachaGroup(value);
  }
  build() {
    return new PromotionalGachaGroup(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setExpireTimeInSeconds(value) {
    this._value._hasExpireTimeInSeconds = true;
    this._value._expireTimeInSeconds = value;
    return this;
  }
  deleteExpireTimeInSeconds() {
    this._value._hasExpireTimeInSeconds = false;
    this._value._expireTimeInSeconds = null;
    return this;
  }
  setChest(value) {
    this._value._hasChest = true;
    this._value._chest = value;
    return this;
  }
  deleteChest() {
    this._value._hasChest = false;
    this._value._chest = null;
    return this;
  }
  setCampaignLevelTrigger(value) {
    this._value._hasCampaignLevelTrigger = true;
    this._value._campaignLevelTrigger = value;
    return this;
  }
  deleteCampaignLevelTrigger() {
    this._value._hasCampaignLevelTrigger = false;
    this._value._campaignLevelTrigger = null;
    return this;
  }
}
PromotionalGachaGroup.Builder = PromotionalGachaGroup_Builder;
class PromotionalGachaGroup_WithParent {
  /**
   * @param {PromotionalGachaGroup} value
   * @param {PromotionalGachaGroup_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return PromotionalGachaGroup.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasExpireTimeInSeconds() {
    if (this._cachedHasExpireTimeInSeconds === undefined) {
      if (this._value.hasExpireTimeInSeconds) {
        this._cachedHasExpireTimeInSeconds = true;
      } else {
        this._cachedHasExpireTimeInSeconds = this._parent ? this._parent.hasExpireTimeInSeconds : false;
      }
    }
    return this._cachedHasExpireTimeInSeconds;
  }
  get expireTimeInSeconds() {
    if (this._cachedExpireTimeInSeconds === undefined) {
      if (this._value.hasExpireTimeInSeconds) {
        this._cachedExpireTimeInSeconds = this._value.expireTimeInSeconds;
      } else {
        this._cachedExpireTimeInSeconds = this._parent ? this._parent.expireTimeInSeconds : this._value.expireTimeInSeconds;
      }
    }
    return this._cachedExpireTimeInSeconds;
  }
  get hasChest() {
    if (this._cachedHasChest === undefined) {
      if (this._value.hasChest) {
        this._cachedHasChest = true;
      } else {
        this._cachedHasChest = this._parent ? this._parent.hasChest : false;
      }
    }
    return this._cachedHasChest;
  }
  get chest() {
    if (!this._cachedChest) {
      if (this._value.hasChest) {
        this._cachedChest = new dcei_wildsky_chest_proto.Chest.WithParent(this._value.chest, this._parent && this._parent.hasChest ? this._parent.chest : null);
      } else {
        this._cachedChest = this._parent ? new dcei_wildsky_chest_proto.Chest.WithParent(dcei_wildsky_chest_proto.Chest.default, this._parent.chest) : dcei_wildsky_chest_proto.Chest.WithParent.default;
      }
    }
    return this._cachedChest;
  }
  get hasCampaignLevelTrigger() {
    if (this._cachedHasCampaignLevelTrigger === undefined) {
      if (this._value.hasCampaignLevelTrigger) {
        this._cachedHasCampaignLevelTrigger = true;
      } else {
        this._cachedHasCampaignLevelTrigger = this._parent ? this._parent.hasCampaignLevelTrigger : false;
      }
    }
    return this._cachedHasCampaignLevelTrigger;
  }
  get campaignLevelTrigger() {
    if (!this._cachedCampaignLevelTrigger) {
      if (this._value.hasCampaignLevelTrigger) {
        this._cachedCampaignLevelTrigger = new PromotionalGachaGroup_CampaignLevelTrigger.WithParent(this._value.campaignLevelTrigger, this._parent && this._parent.hasCampaignLevelTrigger ? this._parent.campaignLevelTrigger : null);
      } else {
        this._cachedCampaignLevelTrigger = this._parent ? new PromotionalGachaGroup_CampaignLevelTrigger.WithParent(PromotionalGachaGroup_CampaignLevelTrigger.default, this._parent.campaignLevelTrigger) : PromotionalGachaGroup_CampaignLevelTrigger.WithParent.default;
      }
    }
    return this._cachedCampaignLevelTrigger;
  }
  update(current, parent) {
    const result = new PromotionalGachaGroup_WithParent(current, parent);
    if (this._cachedChest && this._value.hasChest && current.hasChest) {
      if (this._value.chest === current.chest && this._parent === parent) {
        result._cachedChest = this._cachedChest;
      } else {
        result._cachedChest = this._cachedChest.update(current.chest, parent && parent.hasChest ? parent.chest : null);
      }
    }
    if (this._cachedCampaignLevelTrigger && this._value.hasCampaignLevelTrigger && current.hasCampaignLevelTrigger) {
      if (this._value.campaignLevelTrigger === current.campaignLevelTrigger && this._parent === parent) {
        result._cachedCampaignLevelTrigger = this._cachedCampaignLevelTrigger;
      } else {
        result._cachedCampaignLevelTrigger = this._cachedCampaignLevelTrigger.update(current.campaignLevelTrigger, parent && parent.hasCampaignLevelTrigger ? parent.campaignLevelTrigger : null);
      }
    }
    return result;
  }
}
PromotionalGachaGroup_WithParent.default = new PromotionalGachaGroup_WithParent(PromotionalGachaGroup.default, null);
PromotionalGachaGroup.WithParent = PromotionalGachaGroup_WithParent;
class PromotionalGachaGroup_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get expireTimeInSeconds() {
    if (!this._expireTimeInSeconds) {
      this._expireTimeInSeconds = {
        name: "expireTimeInSeconds",
        Name: "ExpireTimeInSeconds",
        number: 2,
        protoType: 5,
        protoName: "expire_time_in_seconds",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._expireTimeInSeconds;
  }
  get chest() {
    if (!this._chest) {
      this._chest = {
        name: "chest",
        Name: "Chest",
        number: 3,
        protoType: 11,
        protoName: "chest",
        type: dcei_wildsky_chest_proto.Chest,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chest;
  }
  get campaignLevelTrigger() {
    if (!this._campaignLevelTrigger) {
      this._campaignLevelTrigger = {
        name: "campaignLevelTrigger",
        Name: "CampaignLevelTrigger",
        number: 31,
        protoType: 11,
        protoName: "campaign_level_trigger",
        type: PromotionalGachaGroup_CampaignLevelTrigger,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._campaignLevelTrigger;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.expireTimeInSeconds,
        this.chest,
        this.campaignLevelTrigger,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForExpireTimeInSeconds",
        Name: "DummyOneofForExpireTimeInSeconds",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForChest",
        Name: "DummyOneofForChest",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "triggerType",
        Name: "TriggerType",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
PromotionalGachaGroup.descriptor = new PromotionalGachaGroup_Descriptor();
export class GachaGroupStatus {
  get descriptor() {
    return GachaGroupStatus.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasGroupKey = false;
    this._groupKey = null;
    this._hasAvailable = false;
    this._available = null;
    this._hasCurTier = false;
    this._curTier = null;
    this._hasRefreshRemainingMiliseconds = false;
    this._refreshRemainingMiliseconds = null;
    this._hasAdsWatched = false;
    this._adsWatched = null;
    this._hasRefreshRemainingSeconds = false;
    this._refreshRemainingSeconds = null;
    this._hasCumulativeTenDraw = false;
    this._cumulativeTenDraw = null;
    this._hasCumulativeDrawCount = false;
    this._cumulativeDrawCount = null;
  }
  isEmpty() {
    if (this._hasGroupKey) return false;
    if (this._hasAvailable) return false;
    if (this._hasCurTier) return false;
    if (this._hasRefreshRemainingMiliseconds) return false;
    if (this._hasAdsWatched) return false;
    if (this._hasRefreshRemainingSeconds) return false;
    if (this._hasCumulativeTenDraw) return false;
    if (this._hasCumulativeDrawCount) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof GachaGroupStatus) {
      return value;
    }
    return GachaGroupStatus.fromJson(value);
  }
  static fromJson(json) {
    const result = new GachaGroupStatus();
    if (json.groupKey != null) {
      result._hasGroupKey = true;
      result._groupKey = JsonToString.fromJson(json.groupKey);
    }
    if (json.available != null) {
      result._hasAvailable = true;
      result._available = JsonToBoolean.fromJson(json.available);
    }
    if (json.curTier != null) {
      result._hasCurTier = true;
      result._curTier = JsonToInt32.fromJson(json.curTier);
    }
    if (json.refreshRemainingMiliseconds != null) {
      result._hasRefreshRemainingMiliseconds = true;
      result._refreshRemainingMiliseconds = JsonToInt32.fromJson(json.refreshRemainingMiliseconds);
    }
    if (json.adsWatched != null) {
      result._hasAdsWatched = true;
      result._adsWatched = JsonToInt32.fromJson(json.adsWatched);
    }
    if (json.refreshRemainingSeconds != null) {
      result._hasRefreshRemainingSeconds = true;
      result._refreshRemainingSeconds = JsonToDouble.fromJson(json.refreshRemainingSeconds);
    }
    if (json.cumulativeTenDraw != null) {
      result._hasCumulativeTenDraw = true;
      result._cumulativeTenDraw = JsonToInt32.fromJson(json.cumulativeTenDraw);
    }
    if (json.cumulativeDrawCount != null) {
      result._hasCumulativeDrawCount = true;
      result._cumulativeDrawCount = JsonToInt32.fromJson(json.cumulativeDrawCount);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasGroupKey) {
      result.groupKey = JsonToString.toJson(this._groupKey);
    }
    if (this._hasAvailable) {
      result.available = JsonToBoolean.toJson(this._available);
    }
    if (this._hasCurTier) {
      result.curTier = JsonToInt32.toJson(this._curTier);
    }
    if (this._hasRefreshRemainingMiliseconds) {
      result.refreshRemainingMiliseconds = JsonToInt32.toJson(this._refreshRemainingMiliseconds);
    }
    if (this._hasAdsWatched) {
      result.adsWatched = JsonToInt32.toJson(this._adsWatched);
    }
    if (this._hasRefreshRemainingSeconds) {
      result.refreshRemainingSeconds = JsonToDouble.toJson(this._refreshRemainingSeconds);
    }
    if (this._hasCumulativeTenDraw) {
      result.cumulativeTenDraw = JsonToInt32.toJson(this._cumulativeTenDraw);
    }
    if (this._hasCumulativeDrawCount) {
      result.cumulativeDrawCount = JsonToInt32.toJson(this._cumulativeDrawCount);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get groupKey() {
    return this._hasGroupKey ? this._groupKey : JsonToString.default;
  }
  get hasGroupKey() {
    return this._hasGroupKey;
  }
  setGroupKey(path, value) {
    return {type: 'SET', path: path.concat(['groupKey']), value};
  }
  deleteGroupKey(path) {
    return {type: 'DELETE', path: path.concat(['groupKey'])};
  }
  /**
   * @returns {boolean}
   */
  get available() {
    return this._hasAvailable ? this._available : JsonToBoolean.default;
  }
  get hasAvailable() {
    return this._hasAvailable;
  }
  setAvailable(path, value) {
    return {type: 'SET', path: path.concat(['available']), value};
  }
  deleteAvailable(path) {
    return {type: 'DELETE', path: path.concat(['available'])};
  }
  /**
   * @returns {number}
   */
  get curTier() {
    return this._hasCurTier ? this._curTier : JsonToInt32.default;
  }
  get hasCurTier() {
    return this._hasCurTier;
  }
  setCurTier(path, value) {
    return {type: 'SET', path: path.concat(['curTier']), value};
  }
  deleteCurTier(path) {
    return {type: 'DELETE', path: path.concat(['curTier'])};
  }
  /**
   * @returns {number}
   */
  get refreshRemainingMiliseconds() {
    return this._hasRefreshRemainingMiliseconds ? this._refreshRemainingMiliseconds : JsonToInt32.default;
  }
  get hasRefreshRemainingMiliseconds() {
    return this._hasRefreshRemainingMiliseconds;
  }
  setRefreshRemainingMiliseconds(path, value) {
    return {type: 'SET', path: path.concat(['refreshRemainingMiliseconds']), value};
  }
  deleteRefreshRemainingMiliseconds(path) {
    return {type: 'DELETE', path: path.concat(['refreshRemainingMiliseconds'])};
  }
  /**
   * @returns {number}
   */
  get adsWatched() {
    return this._hasAdsWatched ? this._adsWatched : JsonToInt32.default;
  }
  get hasAdsWatched() {
    return this._hasAdsWatched;
  }
  setAdsWatched(path, value) {
    return {type: 'SET', path: path.concat(['adsWatched']), value};
  }
  deleteAdsWatched(path) {
    return {type: 'DELETE', path: path.concat(['adsWatched'])};
  }
  /**
   * @returns {number}
   */
  get refreshRemainingSeconds() {
    return this._hasRefreshRemainingSeconds ? this._refreshRemainingSeconds : JsonToDouble.default;
  }
  get hasRefreshRemainingSeconds() {
    return this._hasRefreshRemainingSeconds;
  }
  setRefreshRemainingSeconds(path, value) {
    return {type: 'SET', path: path.concat(['refreshRemainingSeconds']), value};
  }
  deleteRefreshRemainingSeconds(path) {
    return {type: 'DELETE', path: path.concat(['refreshRemainingSeconds'])};
  }
  /**
   * @returns {number}
   */
  get cumulativeTenDraw() {
    return this._hasCumulativeTenDraw ? this._cumulativeTenDraw : JsonToInt32.default;
  }
  get hasCumulativeTenDraw() {
    return this._hasCumulativeTenDraw;
  }
  setCumulativeTenDraw(path, value) {
    return {type: 'SET', path: path.concat(['cumulativeTenDraw']), value};
  }
  deleteCumulativeTenDraw(path) {
    return {type: 'DELETE', path: path.concat(['cumulativeTenDraw'])};
  }
  /**
   * @returns {number}
   */
  get cumulativeDrawCount() {
    return this._hasCumulativeDrawCount ? this._cumulativeDrawCount : JsonToInt32.default;
  }
  get hasCumulativeDrawCount() {
    return this._hasCumulativeDrawCount;
  }
  setCumulativeDrawCount(path, value) {
    return {type: 'SET', path: path.concat(['cumulativeDrawCount']), value};
  }
  deleteCumulativeDrawCount(path) {
    return {type: 'DELETE', path: path.concat(['cumulativeDrawCount'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "groupKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GachaGroupStatus(this);
              copy._hasGroupKey = true;
              copy._groupKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGroupKey) {
                return this;
              }
              const copy = new GachaGroupStatus(this);
              copy._hasGroupKey = false;
              copy._groupKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "available": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GachaGroupStatus(this);
              copy._hasAvailable = true;
              copy._available = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAvailable) {
                return this;
              }
              const copy = new GachaGroupStatus(this);
              copy._hasAvailable = false;
              copy._available = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "curTier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GachaGroupStatus(this);
              copy._hasCurTier = true;
              copy._curTier = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurTier) {
                return this;
              }
              const copy = new GachaGroupStatus(this);
              copy._hasCurTier = false;
              copy._curTier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "refreshRemainingMiliseconds": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GachaGroupStatus(this);
              copy._hasRefreshRemainingMiliseconds = true;
              copy._refreshRemainingMiliseconds = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRefreshRemainingMiliseconds) {
                return this;
              }
              const copy = new GachaGroupStatus(this);
              copy._hasRefreshRemainingMiliseconds = false;
              copy._refreshRemainingMiliseconds = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "adsWatched": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GachaGroupStatus(this);
              copy._hasAdsWatched = true;
              copy._adsWatched = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAdsWatched) {
                return this;
              }
              const copy = new GachaGroupStatus(this);
              copy._hasAdsWatched = false;
              copy._adsWatched = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "refreshRemainingSeconds": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GachaGroupStatus(this);
              copy._hasRefreshRemainingSeconds = true;
              copy._refreshRemainingSeconds = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRefreshRemainingSeconds) {
                return this;
              }
              const copy = new GachaGroupStatus(this);
              copy._hasRefreshRemainingSeconds = false;
              copy._refreshRemainingSeconds = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "cumulativeTenDraw": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GachaGroupStatus(this);
              copy._hasCumulativeTenDraw = true;
              copy._cumulativeTenDraw = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCumulativeTenDraw) {
                return this;
              }
              const copy = new GachaGroupStatus(this);
              copy._hasCumulativeTenDraw = false;
              copy._cumulativeTenDraw = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "cumulativeDrawCount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GachaGroupStatus(this);
              copy._hasCumulativeDrawCount = true;
              copy._cumulativeDrawCount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCumulativeDrawCount) {
                return this;
              }
              const copy = new GachaGroupStatus(this);
              copy._hasCumulativeDrawCount = false;
              copy._cumulativeDrawCount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {GachaGroupStatus} other
   * @returns {GachaGroupStatus}
   */
  merge(other) {
    const copy = new GachaGroupStatus(this);
    if (other._hasGroupKey) {
      copy._hasGroupKey = true;
      copy._groupKey = other._groupKey;
    }
    if (other._hasAvailable) {
      copy._hasAvailable = true;
      copy._available = other._available;
    }
    if (other._hasCurTier) {
      copy._hasCurTier = true;
      copy._curTier = other._curTier;
    }
    if (other._hasRefreshRemainingMiliseconds) {
      copy._hasRefreshRemainingMiliseconds = true;
      copy._refreshRemainingMiliseconds = other._refreshRemainingMiliseconds;
    }
    if (other._hasAdsWatched) {
      copy._hasAdsWatched = true;
      copy._adsWatched = other._adsWatched;
    }
    if (other._hasRefreshRemainingSeconds) {
      copy._hasRefreshRemainingSeconds = true;
      copy._refreshRemainingSeconds = other._refreshRemainingSeconds;
    }
    if (other._hasCumulativeTenDraw) {
      copy._hasCumulativeTenDraw = true;
      copy._cumulativeTenDraw = other._cumulativeTenDraw;
    }
    if (other._hasCumulativeDrawCount) {
      copy._hasCumulativeDrawCount = true;
      copy._cumulativeDrawCount = other._cumulativeDrawCount;
    }
    return copy;
  }
}
GachaGroupStatus.default = new GachaGroupStatus();
class GachaGroupStatus_Builder {
  constructor(value) {
    this._value = new GachaGroupStatus(value);
  }
  build() {
    return new GachaGroupStatus(this._value);
  }
  setGroupKey(value) {
    this._value._hasGroupKey = true;
    this._value._groupKey = value;
    return this;
  }
  deleteGroupKey() {
    this._value._hasGroupKey = false;
    this._value._groupKey = null;
    return this;
  }
  setAvailable(value) {
    this._value._hasAvailable = true;
    this._value._available = value;
    return this;
  }
  deleteAvailable() {
    this._value._hasAvailable = false;
    this._value._available = null;
    return this;
  }
  setCurTier(value) {
    this._value._hasCurTier = true;
    this._value._curTier = value;
    return this;
  }
  deleteCurTier() {
    this._value._hasCurTier = false;
    this._value._curTier = null;
    return this;
  }
  setRefreshRemainingMiliseconds(value) {
    this._value._hasRefreshRemainingMiliseconds = true;
    this._value._refreshRemainingMiliseconds = value;
    return this;
  }
  deleteRefreshRemainingMiliseconds() {
    this._value._hasRefreshRemainingMiliseconds = false;
    this._value._refreshRemainingMiliseconds = null;
    return this;
  }
  setAdsWatched(value) {
    this._value._hasAdsWatched = true;
    this._value._adsWatched = value;
    return this;
  }
  deleteAdsWatched() {
    this._value._hasAdsWatched = false;
    this._value._adsWatched = null;
    return this;
  }
  setRefreshRemainingSeconds(value) {
    this._value._hasRefreshRemainingSeconds = true;
    this._value._refreshRemainingSeconds = value;
    return this;
  }
  deleteRefreshRemainingSeconds() {
    this._value._hasRefreshRemainingSeconds = false;
    this._value._refreshRemainingSeconds = null;
    return this;
  }
  setCumulativeTenDraw(value) {
    this._value._hasCumulativeTenDraw = true;
    this._value._cumulativeTenDraw = value;
    return this;
  }
  deleteCumulativeTenDraw() {
    this._value._hasCumulativeTenDraw = false;
    this._value._cumulativeTenDraw = null;
    return this;
  }
  setCumulativeDrawCount(value) {
    this._value._hasCumulativeDrawCount = true;
    this._value._cumulativeDrawCount = value;
    return this;
  }
  deleteCumulativeDrawCount() {
    this._value._hasCumulativeDrawCount = false;
    this._value._cumulativeDrawCount = null;
    return this;
  }
}
GachaGroupStatus.Builder = GachaGroupStatus_Builder;
class GachaGroupStatus_WithParent {
  /**
   * @param {GachaGroupStatus} value
   * @param {GachaGroupStatus_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return GachaGroupStatus.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasGroupKey() {
    if (this._cachedHasGroupKey === undefined) {
      if (this._value.hasGroupKey) {
        this._cachedHasGroupKey = true;
      } else {
        this._cachedHasGroupKey = this._parent ? this._parent.hasGroupKey : false;
      }
    }
    return this._cachedHasGroupKey;
  }
  get groupKey() {
    if (this._cachedGroupKey === undefined) {
      if (this._value.hasGroupKey) {
        this._cachedGroupKey = this._value.groupKey;
      } else {
        this._cachedGroupKey = this._parent ? this._parent.groupKey : this._value.groupKey;
      }
    }
    return this._cachedGroupKey;
  }
  get hasAvailable() {
    if (this._cachedHasAvailable === undefined) {
      if (this._value.hasAvailable) {
        this._cachedHasAvailable = true;
      } else {
        this._cachedHasAvailable = this._parent ? this._parent.hasAvailable : false;
      }
    }
    return this._cachedHasAvailable;
  }
  get available() {
    if (this._cachedAvailable === undefined) {
      if (this._value.hasAvailable) {
        this._cachedAvailable = this._value.available;
      } else {
        this._cachedAvailable = this._parent ? this._parent.available : this._value.available;
      }
    }
    return this._cachedAvailable;
  }
  get hasCurTier() {
    if (this._cachedHasCurTier === undefined) {
      if (this._value.hasCurTier) {
        this._cachedHasCurTier = true;
      } else {
        this._cachedHasCurTier = this._parent ? this._parent.hasCurTier : false;
      }
    }
    return this._cachedHasCurTier;
  }
  get curTier() {
    if (this._cachedCurTier === undefined) {
      if (this._value.hasCurTier) {
        this._cachedCurTier = this._value.curTier;
      } else {
        this._cachedCurTier = this._parent ? this._parent.curTier : this._value.curTier;
      }
    }
    return this._cachedCurTier;
  }
  get hasRefreshRemainingMiliseconds() {
    if (this._cachedHasRefreshRemainingMiliseconds === undefined) {
      if (this._value.hasRefreshRemainingMiliseconds) {
        this._cachedHasRefreshRemainingMiliseconds = true;
      } else {
        this._cachedHasRefreshRemainingMiliseconds = this._parent ? this._parent.hasRefreshRemainingMiliseconds : false;
      }
    }
    return this._cachedHasRefreshRemainingMiliseconds;
  }
  get refreshRemainingMiliseconds() {
    if (this._cachedRefreshRemainingMiliseconds === undefined) {
      if (this._value.hasRefreshRemainingMiliseconds) {
        this._cachedRefreshRemainingMiliseconds = this._value.refreshRemainingMiliseconds;
      } else {
        this._cachedRefreshRemainingMiliseconds = this._parent ? this._parent.refreshRemainingMiliseconds : this._value.refreshRemainingMiliseconds;
      }
    }
    return this._cachedRefreshRemainingMiliseconds;
  }
  get hasAdsWatched() {
    if (this._cachedHasAdsWatched === undefined) {
      if (this._value.hasAdsWatched) {
        this._cachedHasAdsWatched = true;
      } else {
        this._cachedHasAdsWatched = this._parent ? this._parent.hasAdsWatched : false;
      }
    }
    return this._cachedHasAdsWatched;
  }
  get adsWatched() {
    if (this._cachedAdsWatched === undefined) {
      if (this._value.hasAdsWatched) {
        this._cachedAdsWatched = this._value.adsWatched;
      } else {
        this._cachedAdsWatched = this._parent ? this._parent.adsWatched : this._value.adsWatched;
      }
    }
    return this._cachedAdsWatched;
  }
  get hasRefreshRemainingSeconds() {
    if (this._cachedHasRefreshRemainingSeconds === undefined) {
      if (this._value.hasRefreshRemainingSeconds) {
        this._cachedHasRefreshRemainingSeconds = true;
      } else {
        this._cachedHasRefreshRemainingSeconds = this._parent ? this._parent.hasRefreshRemainingSeconds : false;
      }
    }
    return this._cachedHasRefreshRemainingSeconds;
  }
  get refreshRemainingSeconds() {
    if (this._cachedRefreshRemainingSeconds === undefined) {
      if (this._value.hasRefreshRemainingSeconds) {
        this._cachedRefreshRemainingSeconds = this._value.refreshRemainingSeconds;
      } else {
        this._cachedRefreshRemainingSeconds = this._parent ? this._parent.refreshRemainingSeconds : this._value.refreshRemainingSeconds;
      }
    }
    return this._cachedRefreshRemainingSeconds;
  }
  get hasCumulativeTenDraw() {
    if (this._cachedHasCumulativeTenDraw === undefined) {
      if (this._value.hasCumulativeTenDraw) {
        this._cachedHasCumulativeTenDraw = true;
      } else {
        this._cachedHasCumulativeTenDraw = this._parent ? this._parent.hasCumulativeTenDraw : false;
      }
    }
    return this._cachedHasCumulativeTenDraw;
  }
  get cumulativeTenDraw() {
    if (this._cachedCumulativeTenDraw === undefined) {
      if (this._value.hasCumulativeTenDraw) {
        this._cachedCumulativeTenDraw = this._value.cumulativeTenDraw;
      } else {
        this._cachedCumulativeTenDraw = this._parent ? this._parent.cumulativeTenDraw : this._value.cumulativeTenDraw;
      }
    }
    return this._cachedCumulativeTenDraw;
  }
  get hasCumulativeDrawCount() {
    if (this._cachedHasCumulativeDrawCount === undefined) {
      if (this._value.hasCumulativeDrawCount) {
        this._cachedHasCumulativeDrawCount = true;
      } else {
        this._cachedHasCumulativeDrawCount = this._parent ? this._parent.hasCumulativeDrawCount : false;
      }
    }
    return this._cachedHasCumulativeDrawCount;
  }
  get cumulativeDrawCount() {
    if (this._cachedCumulativeDrawCount === undefined) {
      if (this._value.hasCumulativeDrawCount) {
        this._cachedCumulativeDrawCount = this._value.cumulativeDrawCount;
      } else {
        this._cachedCumulativeDrawCount = this._parent ? this._parent.cumulativeDrawCount : this._value.cumulativeDrawCount;
      }
    }
    return this._cachedCumulativeDrawCount;
  }
  update(current, parent) {
    const result = new GachaGroupStatus_WithParent(current, parent);
    return result;
  }
}
GachaGroupStatus_WithParent.default = new GachaGroupStatus_WithParent(GachaGroupStatus.default, null);
GachaGroupStatus.WithParent = GachaGroupStatus_WithParent;
class GachaGroupStatus_Descriptor {
  get groupKey() {
    if (!this._groupKey) {
      this._groupKey = {
        name: "groupKey",
        Name: "GroupKey",
        number: 1,
        protoType: 9,
        protoName: "group_key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._groupKey;
  }
  get available() {
    if (!this._available) {
      this._available = {
        name: "available",
        Name: "Available",
        number: 2,
        protoType: 8,
        protoName: "available",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._available;
  }
  get curTier() {
    if (!this._curTier) {
      this._curTier = {
        name: "curTier",
        Name: "CurTier",
        number: 3,
        protoType: 5,
        protoName: "cur_tier",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._curTier;
  }
  get refreshRemainingMiliseconds() {
    if (!this._refreshRemainingMiliseconds) {
      this._refreshRemainingMiliseconds = {
        name: "refreshRemainingMiliseconds",
        Name: "RefreshRemainingMiliseconds",
        number: 4,
        protoType: 5,
        protoName: "refresh_remaining_miliseconds",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._refreshRemainingMiliseconds;
  }
  get adsWatched() {
    if (!this._adsWatched) {
      this._adsWatched = {
        name: "adsWatched",
        Name: "AdsWatched",
        number: 5,
        protoType: 5,
        protoName: "ads_watched",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._adsWatched;
  }
  get refreshRemainingSeconds() {
    if (!this._refreshRemainingSeconds) {
      this._refreshRemainingSeconds = {
        name: "refreshRemainingSeconds",
        Name: "RefreshRemainingSeconds",
        number: 6,
        protoType: 1,
        protoName: "refresh_remaining_seconds",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._refreshRemainingSeconds;
  }
  get cumulativeTenDraw() {
    if (!this._cumulativeTenDraw) {
      this._cumulativeTenDraw = {
        name: "cumulativeTenDraw",
        Name: "CumulativeTenDraw",
        number: 7,
        protoType: 5,
        protoName: "cumulative_ten_draw",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cumulativeTenDraw;
  }
  get cumulativeDrawCount() {
    if (!this._cumulativeDrawCount) {
      this._cumulativeDrawCount = {
        name: "cumulativeDrawCount",
        Name: "CumulativeDrawCount",
        number: 8,
        protoType: 5,
        protoName: "cumulative_draw_count",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cumulativeDrawCount;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.groupKey,
        this.available,
        this.curTier,
        this.refreshRemainingMiliseconds,
        this.adsWatched,
        this.refreshRemainingSeconds,
        this.cumulativeTenDraw,
        this.cumulativeDrawCount,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForGroupKey",
        Name: "DummyOneofForGroupKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAvailable",
        Name: "DummyOneofForAvailable",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCurTier",
        Name: "DummyOneofForCurTier",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRefreshRemainingMiliseconds",
        Name: "DummyOneofForRefreshRemainingMiliseconds",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAdsWatched",
        Name: "DummyOneofForAdsWatched",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRefreshRemainingSeconds",
        Name: "DummyOneofForRefreshRemainingSeconds",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCumulativeTenDraw",
        Name: "DummyOneofForCumulativeTenDraw",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCumulativeDrawCount",
        Name: "DummyOneofForCumulativeDrawCount",
        fields: [
          this.fields[7],
        ],
      });
    }
    return this._oneofs;
  }
}
GachaGroupStatus.descriptor = new GachaGroupStatus_Descriptor();
class PromotionalGachaGroupStatus_GroupState {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "NONE": return 0;
        case "EXPIRED": return 1;
        case "INACTIVATED": return 2;
        case "ACTIVE": return 3;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return PromotionalGachaGroupStatus_GroupState.fromJson(value);
  }
  static fromReact(e) {
    return PromotionalGachaGroupStatus_GroupState.fromJson(e);
  }
}
PromotionalGachaGroupStatus_GroupState.NONE = 0;
PromotionalGachaGroupStatus_GroupState.EXPIRED = 1;
PromotionalGachaGroupStatus_GroupState.INACTIVATED = 2;
PromotionalGachaGroupStatus_GroupState.ACTIVE = 3;
PromotionalGachaGroupStatus_GroupState.default = 0;
PromotionalGachaGroupStatus_GroupState.values = {
  NONE: 0,
  EXPIRED: 1,
  INACTIVATED: 2,
  ACTIVE: 3,
};
PromotionalGachaGroupStatus_GroupState.names = {
  0: "NONE",
  1: "EXPIRED",
  2: "INACTIVATED",
  3: "ACTIVE",
};
export class PromotionalGachaGroupStatus {
  get descriptor() {
    return PromotionalGachaGroupStatus.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasGroupKey = false;
    this._groupKey = null;
    this._hasState = false;
    this._state = null;
    this._hasExpireRemainingSeconds = false;
    this._expireRemainingSeconds = null;
    this._hasCumulativeTenDraw = false;
    this._cumulativeTenDraw = null;
  }
  isEmpty() {
    if (this._hasGroupKey) return false;
    if (this._hasState) return false;
    if (this._hasExpireRemainingSeconds) return false;
    if (this._hasCumulativeTenDraw) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof PromotionalGachaGroupStatus) {
      return value;
    }
    return PromotionalGachaGroupStatus.fromJson(value);
  }
  static fromJson(json) {
    const result = new PromotionalGachaGroupStatus();
    if (json.groupKey != null) {
      result._hasGroupKey = true;
      result._groupKey = JsonToString.fromJson(json.groupKey);
    }
    if (json.state != null) {
      result._hasState = true;
      result._state = PromotionalGachaGroupStatus_GroupState.fromJson(json.state);
    }
    if (json.expireRemainingSeconds != null) {
      result._hasExpireRemainingSeconds = true;
      result._expireRemainingSeconds = JsonToDouble.fromJson(json.expireRemainingSeconds);
    }
    if (json.cumulativeTenDraw != null) {
      result._hasCumulativeTenDraw = true;
      result._cumulativeTenDraw = JsonToInt32.fromJson(json.cumulativeTenDraw);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasGroupKey) {
      result.groupKey = JsonToString.toJson(this._groupKey);
    }
    if (this._hasState) {
      result.state = PromotionalGachaGroupStatus_GroupState.toJson(this._state);
    }
    if (this._hasExpireRemainingSeconds) {
      result.expireRemainingSeconds = JsonToDouble.toJson(this._expireRemainingSeconds);
    }
    if (this._hasCumulativeTenDraw) {
      result.cumulativeTenDraw = JsonToInt32.toJson(this._cumulativeTenDraw);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get groupKey() {
    return this._hasGroupKey ? this._groupKey : JsonToString.default;
  }
  get hasGroupKey() {
    return this._hasGroupKey;
  }
  setGroupKey(path, value) {
    return {type: 'SET', path: path.concat(['groupKey']), value};
  }
  deleteGroupKey(path) {
    return {type: 'DELETE', path: path.concat(['groupKey'])};
  }
  /**
   * @returns {number}
   */
  get state() {
    return this._hasState ? this._state : PromotionalGachaGroupStatus_GroupState.default;
  }
  get hasState() {
    return this._hasState;
  }
  setState(path, value) {
    return {type: 'SET', path: path.concat(['state']), value};
  }
  deleteState(path) {
    return {type: 'DELETE', path: path.concat(['state'])};
  }
  /**
   * @returns {number}
   */
  get expireRemainingSeconds() {
    return this._hasExpireRemainingSeconds ? this._expireRemainingSeconds : JsonToDouble.default;
  }
  get hasExpireRemainingSeconds() {
    return this._hasExpireRemainingSeconds;
  }
  setExpireRemainingSeconds(path, value) {
    return {type: 'SET', path: path.concat(['expireRemainingSeconds']), value};
  }
  deleteExpireRemainingSeconds(path) {
    return {type: 'DELETE', path: path.concat(['expireRemainingSeconds'])};
  }
  /**
   * @returns {number}
   */
  get cumulativeTenDraw() {
    return this._hasCumulativeTenDraw ? this._cumulativeTenDraw : JsonToInt32.default;
  }
  get hasCumulativeTenDraw() {
    return this._hasCumulativeTenDraw;
  }
  setCumulativeTenDraw(path, value) {
    return {type: 'SET', path: path.concat(['cumulativeTenDraw']), value};
  }
  deleteCumulativeTenDraw(path) {
    return {type: 'DELETE', path: path.concat(['cumulativeTenDraw'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "groupKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionalGachaGroupStatus(this);
              copy._hasGroupKey = true;
              copy._groupKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGroupKey) {
                return this;
              }
              const copy = new PromotionalGachaGroupStatus(this);
              copy._hasGroupKey = false;
              copy._groupKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "state": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionalGachaGroupStatus(this);
              copy._hasState = true;
              copy._state = PromotionalGachaGroupStatus_GroupState.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasState) {
                return this;
              }
              const copy = new PromotionalGachaGroupStatus(this);
              copy._hasState = false;
              copy._state = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "expireRemainingSeconds": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionalGachaGroupStatus(this);
              copy._hasExpireRemainingSeconds = true;
              copy._expireRemainingSeconds = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasExpireRemainingSeconds) {
                return this;
              }
              const copy = new PromotionalGachaGroupStatus(this);
              copy._hasExpireRemainingSeconds = false;
              copy._expireRemainingSeconds = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "cumulativeTenDraw": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionalGachaGroupStatus(this);
              copy._hasCumulativeTenDraw = true;
              copy._cumulativeTenDraw = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCumulativeTenDraw) {
                return this;
              }
              const copy = new PromotionalGachaGroupStatus(this);
              copy._hasCumulativeTenDraw = false;
              copy._cumulativeTenDraw = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {PromotionalGachaGroupStatus} other
   * @returns {PromotionalGachaGroupStatus}
   */
  merge(other) {
    const copy = new PromotionalGachaGroupStatus(this);
    if (other._hasGroupKey) {
      copy._hasGroupKey = true;
      copy._groupKey = other._groupKey;
    }
    if (other._hasState) {
      copy._hasState = true;
      copy._state = other._state;
    }
    if (other._hasExpireRemainingSeconds) {
      copy._hasExpireRemainingSeconds = true;
      copy._expireRemainingSeconds = other._expireRemainingSeconds;
    }
    if (other._hasCumulativeTenDraw) {
      copy._hasCumulativeTenDraw = true;
      copy._cumulativeTenDraw = other._cumulativeTenDraw;
    }
    return copy;
  }
}
PromotionalGachaGroupStatus.default = new PromotionalGachaGroupStatus();
PromotionalGachaGroupStatus.GroupState = PromotionalGachaGroupStatus_GroupState;
class PromotionalGachaGroupStatus_Builder {
  constructor(value) {
    this._value = new PromotionalGachaGroupStatus(value);
  }
  build() {
    return new PromotionalGachaGroupStatus(this._value);
  }
  setGroupKey(value) {
    this._value._hasGroupKey = true;
    this._value._groupKey = value;
    return this;
  }
  deleteGroupKey() {
    this._value._hasGroupKey = false;
    this._value._groupKey = null;
    return this;
  }
  setState(value) {
    this._value._hasState = true;
    this._value._state = value;
    return this;
  }
  deleteState() {
    this._value._hasState = false;
    this._value._state = null;
    return this;
  }
  setExpireRemainingSeconds(value) {
    this._value._hasExpireRemainingSeconds = true;
    this._value._expireRemainingSeconds = value;
    return this;
  }
  deleteExpireRemainingSeconds() {
    this._value._hasExpireRemainingSeconds = false;
    this._value._expireRemainingSeconds = null;
    return this;
  }
  setCumulativeTenDraw(value) {
    this._value._hasCumulativeTenDraw = true;
    this._value._cumulativeTenDraw = value;
    return this;
  }
  deleteCumulativeTenDraw() {
    this._value._hasCumulativeTenDraw = false;
    this._value._cumulativeTenDraw = null;
    return this;
  }
}
PromotionalGachaGroupStatus.Builder = PromotionalGachaGroupStatus_Builder;
class PromotionalGachaGroupStatus_WithParent {
  /**
   * @param {PromotionalGachaGroupStatus} value
   * @param {PromotionalGachaGroupStatus_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return PromotionalGachaGroupStatus.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasGroupKey() {
    if (this._cachedHasGroupKey === undefined) {
      if (this._value.hasGroupKey) {
        this._cachedHasGroupKey = true;
      } else {
        this._cachedHasGroupKey = this._parent ? this._parent.hasGroupKey : false;
      }
    }
    return this._cachedHasGroupKey;
  }
  get groupKey() {
    if (this._cachedGroupKey === undefined) {
      if (this._value.hasGroupKey) {
        this._cachedGroupKey = this._value.groupKey;
      } else {
        this._cachedGroupKey = this._parent ? this._parent.groupKey : this._value.groupKey;
      }
    }
    return this._cachedGroupKey;
  }
  get hasState() {
    if (this._cachedHasState === undefined) {
      if (this._value.hasState) {
        this._cachedHasState = true;
      } else {
        this._cachedHasState = this._parent ? this._parent.hasState : false;
      }
    }
    return this._cachedHasState;
  }
  get state() {
    if (this._cachedState === undefined) {
      if (this._value.hasState) {
        this._cachedState = this._value.state;
      } else {
        this._cachedState = this._parent ? this._parent.state : this._value.state;
      }
    }
    return this._cachedState;
  }
  get hasExpireRemainingSeconds() {
    if (this._cachedHasExpireRemainingSeconds === undefined) {
      if (this._value.hasExpireRemainingSeconds) {
        this._cachedHasExpireRemainingSeconds = true;
      } else {
        this._cachedHasExpireRemainingSeconds = this._parent ? this._parent.hasExpireRemainingSeconds : false;
      }
    }
    return this._cachedHasExpireRemainingSeconds;
  }
  get expireRemainingSeconds() {
    if (this._cachedExpireRemainingSeconds === undefined) {
      if (this._value.hasExpireRemainingSeconds) {
        this._cachedExpireRemainingSeconds = this._value.expireRemainingSeconds;
      } else {
        this._cachedExpireRemainingSeconds = this._parent ? this._parent.expireRemainingSeconds : this._value.expireRemainingSeconds;
      }
    }
    return this._cachedExpireRemainingSeconds;
  }
  get hasCumulativeTenDraw() {
    if (this._cachedHasCumulativeTenDraw === undefined) {
      if (this._value.hasCumulativeTenDraw) {
        this._cachedHasCumulativeTenDraw = true;
      } else {
        this._cachedHasCumulativeTenDraw = this._parent ? this._parent.hasCumulativeTenDraw : false;
      }
    }
    return this._cachedHasCumulativeTenDraw;
  }
  get cumulativeTenDraw() {
    if (this._cachedCumulativeTenDraw === undefined) {
      if (this._value.hasCumulativeTenDraw) {
        this._cachedCumulativeTenDraw = this._value.cumulativeTenDraw;
      } else {
        this._cachedCumulativeTenDraw = this._parent ? this._parent.cumulativeTenDraw : this._value.cumulativeTenDraw;
      }
    }
    return this._cachedCumulativeTenDraw;
  }
  update(current, parent) {
    const result = new PromotionalGachaGroupStatus_WithParent(current, parent);
    return result;
  }
}
PromotionalGachaGroupStatus_WithParent.default = new PromotionalGachaGroupStatus_WithParent(PromotionalGachaGroupStatus.default, null);
PromotionalGachaGroupStatus.WithParent = PromotionalGachaGroupStatus_WithParent;
class PromotionalGachaGroupStatus_Descriptor {
  get groupKey() {
    if (!this._groupKey) {
      this._groupKey = {
        name: "groupKey",
        Name: "GroupKey",
        number: 1,
        protoType: 9,
        protoName: "group_key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._groupKey;
  }
  get state() {
    if (!this._state) {
      this._state = {
        name: "state",
        Name: "State",
        number: 2,
        protoType: 14,
        protoName: "state",
        type: PromotionalGachaGroupStatus_GroupState,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._state;
  }
  get expireRemainingSeconds() {
    if (!this._expireRemainingSeconds) {
      this._expireRemainingSeconds = {
        name: "expireRemainingSeconds",
        Name: "ExpireRemainingSeconds",
        number: 3,
        protoType: 1,
        protoName: "expire_remaining_seconds",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._expireRemainingSeconds;
  }
  get cumulativeTenDraw() {
    if (!this._cumulativeTenDraw) {
      this._cumulativeTenDraw = {
        name: "cumulativeTenDraw",
        Name: "CumulativeTenDraw",
        number: 4,
        protoType: 5,
        protoName: "cumulative_ten_draw",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cumulativeTenDraw;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.groupKey,
        this.state,
        this.expireRemainingSeconds,
        this.cumulativeTenDraw,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForGroupKey",
        Name: "DummyOneofForGroupKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForState",
        Name: "DummyOneofForState",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForExpireRemainingSeconds",
        Name: "DummyOneofForExpireRemainingSeconds",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCumulativeTenDraw",
        Name: "DummyOneofForCumulativeTenDraw",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
PromotionalGachaGroupStatus.descriptor = new PromotionalGachaGroupStatus_Descriptor();
export class GachaLevelGroup {
  get descriptor() {
    return GachaLevelGroup.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._gachaGroups = [];
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._gachaGroups.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof GachaLevelGroup) {
      return value;
    }
    return GachaLevelGroup.fromJson(value);
  }
  static fromJson(json) {
    const result = new GachaLevelGroup();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    result._gachaGroups = JsonToList(json.gachaGroups, GachaGroup);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._gachaGroups.length > 0) {
      result.gachaGroups = ArrayToJson(this._gachaGroups, GachaGroup);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {GachaGroup[]}
   */
  get gachaGroups() {
    return this._gachaGroups;
  }
  addGachaGroups(path, value) {
    return {type: 'ADD', path: path.concat(['gachaGroups']), value: value.toJson()};
  }
  setGachaGroups(path, value) {
    return {type: 'SET', path: path.concat(['gachaGroups']), value: ArrayToJson(value, GachaGroup)};
  }
  setGachaGroupsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['gachaGroups', key]), value: value.toJson()};
  }
  deleteGachaGroups(path) {
    return {type: 'DELETE', path: path.concat(['gachaGroups'])};
  }
  deleteGachaGroupsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['gachaGroups', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GachaLevelGroup(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new GachaLevelGroup(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "gachaGroups": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GachaLevelGroup(this);
              copy._gachaGroups = [];        for (let i of value) {
                copy._gachaGroups.push(GachaGroup.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new GachaLevelGroup(this);
              copy._gachaGroups = copy._gachaGroups.concat([GachaGroup.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._gachaGroups.length === 0) {
                return this;
              }
              const copy = new GachaLevelGroup(this);
              copy._gachaGroups = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._gachaGroups.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new GachaLevelGroup(this);
              copy._gachaGroups = copy._gachaGroups.slice();
              copy._gachaGroups[path[1]] = GachaGroup.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new GachaLevelGroup(this);
              copy._gachaGroups = copy._gachaGroups.slice(0, path[1]).concat(copy._gachaGroups.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._gachaGroups.length) {
            return this;
          }
          const oldValue = this._gachaGroups[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new GachaLevelGroup(this);
          copy._gachaGroups = copy._gachaGroups.slice();
          copy._gachaGroups[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {GachaLevelGroup} other
   * @returns {GachaLevelGroup}
   */
  merge(other) {
    const copy = new GachaLevelGroup(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    copy._gachaGroups = this._gachaGroups.concat(other._gachaGroups);
    return copy;
  }
}
GachaLevelGroup.default = new GachaLevelGroup();
class GachaLevelGroup_Builder {
  constructor(value) {
    this._value = new GachaLevelGroup(value);
  }
  build() {
    return new GachaLevelGroup(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  addAllGachaGroups(values) {
    this._value._gachaGroups = this._value._gachaGroups.concat(values);
    return this;
  }
  addGachaGroups(value) {
    this._value._gachaGroups = this._value._gachaGroups.concat([value]);
    return this;
  }
  setGachaGroups(index, value) {
    this._value._gachaGroups = this._value._gachaGroups.concat();
    this._value._gachaGroups[index] = value;
    return this;
  }
  clearGachaGroups() {
    this._value._gachaGroups = [];
    return this;
  }
}
GachaLevelGroup.Builder = GachaLevelGroup_Builder;
class GachaLevelGroup_WithParent {
  /**
   * @param {GachaLevelGroup} value
   * @param {GachaLevelGroup_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return GachaLevelGroup.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get selfGachaGroups() {
    if (!this._selfGachaGroups) {
      this._selfGachaGroups = [];
      for (let i of this._value.gachaGroups) {
        this._selfGachaGroups.push(new GachaGroup.WithParent(i, null));
      }
    }
    return this._selfGachaGroups;
  }
  get inherentGachaGroups() {
    if (!this._inherentGachaGroups) {
      this._inherentGachaGroups = this._parent ? this._parent.gachaGroups : [];
    }
    return this._inherentGachaGroups;
  }
  get gachaGroups() {
    if (!this._allGachaGroups) {
      this._allGachaGroups = this._parent ? this._parent.gachaGroups.concat(this.selfGachaGroups) : this.selfGachaGroups;
    }
    return this._allGachaGroups;
  }
  update(current, parent) {
    const result = new GachaLevelGroup_WithParent(current, parent);
    if (this._selfGachaGroups) {
      if (this._value.gachaGroups === current.gachaGroups) {
        result._selfGachaGroups = this._selfGachaGroups;
      } else {
        result._selfGachaGroups = [];
        for (let i = 0; i < current.gachaGroups.length; i++) {
          const oldValue = this._value.gachaGroups[i];
          if (oldValue) {
            const oldCache = this._selfGachaGroups[i];
            if (oldValue === current.gachaGroups[i]) {
              result._selfGachaGroups[i] = oldCache;
            } else {
              result._selfGachaGroups[i] = oldCache.update(current.gachaGroups[i], null);
            }
          } else {
            result._selfGachaGroups[i] = new GachaGroup.WithParent(current.gachaGroups[i], null);
          }
        }
      }
    }
    return result;
  }
}
GachaLevelGroup_WithParent.default = new GachaLevelGroup_WithParent(GachaLevelGroup.default, null);
GachaLevelGroup.WithParent = GachaLevelGroup_WithParent;
class GachaLevelGroup_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get gachaGroups() {
    if (!this._gachaGroups) {
      this._gachaGroups = {
        name: "gachaGroups",
        Name: "GachaGroups",
        number: 4,
        protoType: 11,
        protoName: "gacha_groups",
        type: GachaGroup,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._gachaGroups;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.gachaGroups,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
GachaLevelGroup.descriptor = new GachaLevelGroup_Descriptor();
export class GachaConfig {
  get descriptor() {
    return GachaConfig.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._gachaLevelGroups = [];
    this._promotionalGachaGroups = [];
  }
  isEmpty() {
    if (this._gachaLevelGroups.length > 0) return false;
    if (this._promotionalGachaGroups.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof GachaConfig) {
      return value;
    }
    return GachaConfig.fromJson(value);
  }
  static fromJson(json) {
    const result = new GachaConfig();
    result._gachaLevelGroups = JsonToList(json.gachaLevelGroups, GachaLevelGroup);
    result._promotionalGachaGroups = JsonToList(json.promotionalGachaGroups, PromotionalGachaGroup);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._gachaLevelGroups.length > 0) {
      result.gachaLevelGroups = ArrayToJson(this._gachaLevelGroups, GachaLevelGroup);
    }
    if (this._promotionalGachaGroups.length > 0) {
      result.promotionalGachaGroups = ArrayToJson(this._promotionalGachaGroups, PromotionalGachaGroup);
    }
    return result;
  }
  /**
   * @returns {GachaLevelGroup[]}
   */
  get gachaLevelGroups() {
    return this._gachaLevelGroups;
  }
  addGachaLevelGroups(path, value) {
    return {type: 'ADD', path: path.concat(['gachaLevelGroups']), value: value.toJson()};
  }
  setGachaLevelGroups(path, value) {
    return {type: 'SET', path: path.concat(['gachaLevelGroups']), value: ArrayToJson(value, GachaLevelGroup)};
  }
  setGachaLevelGroupsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['gachaLevelGroups', key]), value: value.toJson()};
  }
  deleteGachaLevelGroups(path) {
    return {type: 'DELETE', path: path.concat(['gachaLevelGroups'])};
  }
  deleteGachaLevelGroupsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['gachaLevelGroups', key])};
  }
  /**
   * @returns {PromotionalGachaGroup[]}
   */
  get promotionalGachaGroups() {
    return this._promotionalGachaGroups;
  }
  addPromotionalGachaGroups(path, value) {
    return {type: 'ADD', path: path.concat(['promotionalGachaGroups']), value: value.toJson()};
  }
  setPromotionalGachaGroups(path, value) {
    return {type: 'SET', path: path.concat(['promotionalGachaGroups']), value: ArrayToJson(value, PromotionalGachaGroup)};
  }
  setPromotionalGachaGroupsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['promotionalGachaGroups', key]), value: value.toJson()};
  }
  deletePromotionalGachaGroups(path) {
    return {type: 'DELETE', path: path.concat(['promotionalGachaGroups'])};
  }
  deletePromotionalGachaGroupsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['promotionalGachaGroups', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "gachaLevelGroups": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GachaConfig(this);
              copy._gachaLevelGroups = [];        for (let i of value) {
                copy._gachaLevelGroups.push(GachaLevelGroup.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new GachaConfig(this);
              copy._gachaLevelGroups = copy._gachaLevelGroups.concat([GachaLevelGroup.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._gachaLevelGroups.length === 0) {
                return this;
              }
              const copy = new GachaConfig(this);
              copy._gachaLevelGroups = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._gachaLevelGroups.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new GachaConfig(this);
              copy._gachaLevelGroups = copy._gachaLevelGroups.slice();
              copy._gachaLevelGroups[path[1]] = GachaLevelGroup.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new GachaConfig(this);
              copy._gachaLevelGroups = copy._gachaLevelGroups.slice(0, path[1]).concat(copy._gachaLevelGroups.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._gachaLevelGroups.length) {
            return this;
          }
          const oldValue = this._gachaLevelGroups[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new GachaConfig(this);
          copy._gachaLevelGroups = copy._gachaLevelGroups.slice();
          copy._gachaLevelGroups[key] = newValue;
          return copy;
        }
      }
      case "promotionalGachaGroups": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GachaConfig(this);
              copy._promotionalGachaGroups = [];        for (let i of value) {
                copy._promotionalGachaGroups.push(PromotionalGachaGroup.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new GachaConfig(this);
              copy._promotionalGachaGroups = copy._promotionalGachaGroups.concat([PromotionalGachaGroup.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._promotionalGachaGroups.length === 0) {
                return this;
              }
              const copy = new GachaConfig(this);
              copy._promotionalGachaGroups = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._promotionalGachaGroups.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new GachaConfig(this);
              copy._promotionalGachaGroups = copy._promotionalGachaGroups.slice();
              copy._promotionalGachaGroups[path[1]] = PromotionalGachaGroup.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new GachaConfig(this);
              copy._promotionalGachaGroups = copy._promotionalGachaGroups.slice(0, path[1]).concat(copy._promotionalGachaGroups.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._promotionalGachaGroups.length) {
            return this;
          }
          const oldValue = this._promotionalGachaGroups[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new GachaConfig(this);
          copy._promotionalGachaGroups = copy._promotionalGachaGroups.slice();
          copy._promotionalGachaGroups[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {GachaConfig} other
   * @returns {GachaConfig}
   */
  merge(other) {
    const copy = new GachaConfig(this);
    copy._gachaLevelGroups = this._gachaLevelGroups.concat(other._gachaLevelGroups);
    copy._promotionalGachaGroups = this._promotionalGachaGroups.concat(other._promotionalGachaGroups);
    return copy;
  }
}
GachaConfig.default = new GachaConfig();
class GachaConfig_Builder {
  constructor(value) {
    this._value = new GachaConfig(value);
  }
  build() {
    return new GachaConfig(this._value);
  }
  addAllGachaLevelGroups(values) {
    this._value._gachaLevelGroups = this._value._gachaLevelGroups.concat(values);
    return this;
  }
  addGachaLevelGroups(value) {
    this._value._gachaLevelGroups = this._value._gachaLevelGroups.concat([value]);
    return this;
  }
  setGachaLevelGroups(index, value) {
    this._value._gachaLevelGroups = this._value._gachaLevelGroups.concat();
    this._value._gachaLevelGroups[index] = value;
    return this;
  }
  clearGachaLevelGroups() {
    this._value._gachaLevelGroups = [];
    return this;
  }
  addAllPromotionalGachaGroups(values) {
    this._value._promotionalGachaGroups = this._value._promotionalGachaGroups.concat(values);
    return this;
  }
  addPromotionalGachaGroups(value) {
    this._value._promotionalGachaGroups = this._value._promotionalGachaGroups.concat([value]);
    return this;
  }
  setPromotionalGachaGroups(index, value) {
    this._value._promotionalGachaGroups = this._value._promotionalGachaGroups.concat();
    this._value._promotionalGachaGroups[index] = value;
    return this;
  }
  clearPromotionalGachaGroups() {
    this._value._promotionalGachaGroups = [];
    return this;
  }
}
GachaConfig.Builder = GachaConfig_Builder;
class GachaConfig_WithParent {
  /**
   * @param {GachaConfig} value
   * @param {GachaConfig_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return GachaConfig.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfGachaLevelGroups() {
    if (!this._selfGachaLevelGroups) {
      this._selfGachaLevelGroups = [];
      for (let i of this._value.gachaLevelGroups) {
        this._selfGachaLevelGroups.push(new GachaLevelGroup.WithParent(i, null));
      }
    }
    return this._selfGachaLevelGroups;
  }
  get inherentGachaLevelGroups() {
    if (!this._inherentGachaLevelGroups) {
      this._inherentGachaLevelGroups = this._parent ? this._parent.gachaLevelGroups : [];
    }
    return this._inherentGachaLevelGroups;
  }
  get gachaLevelGroups() {
    if (!this._allGachaLevelGroups) {
      this._allGachaLevelGroups = this._parent ? this._parent.gachaLevelGroups.concat(this.selfGachaLevelGroups) : this.selfGachaLevelGroups;
    }
    return this._allGachaLevelGroups;
  }
  get selfPromotionalGachaGroups() {
    if (!this._selfPromotionalGachaGroups) {
      this._selfPromotionalGachaGroups = [];
      for (let i of this._value.promotionalGachaGroups) {
        this._selfPromotionalGachaGroups.push(new PromotionalGachaGroup.WithParent(i, null));
      }
    }
    return this._selfPromotionalGachaGroups;
  }
  get inherentPromotionalGachaGroups() {
    if (!this._inherentPromotionalGachaGroups) {
      this._inherentPromotionalGachaGroups = this._parent ? this._parent.promotionalGachaGroups : [];
    }
    return this._inherentPromotionalGachaGroups;
  }
  get promotionalGachaGroups() {
    if (!this._allPromotionalGachaGroups) {
      this._allPromotionalGachaGroups = this._parent ? this._parent.promotionalGachaGroups.concat(this.selfPromotionalGachaGroups) : this.selfPromotionalGachaGroups;
    }
    return this._allPromotionalGachaGroups;
  }
  update(current, parent) {
    const result = new GachaConfig_WithParent(current, parent);
    if (this._selfGachaLevelGroups) {
      if (this._value.gachaLevelGroups === current.gachaLevelGroups) {
        result._selfGachaLevelGroups = this._selfGachaLevelGroups;
      } else {
        result._selfGachaLevelGroups = [];
        for (let i = 0; i < current.gachaLevelGroups.length; i++) {
          const oldValue = this._value.gachaLevelGroups[i];
          if (oldValue) {
            const oldCache = this._selfGachaLevelGroups[i];
            if (oldValue === current.gachaLevelGroups[i]) {
              result._selfGachaLevelGroups[i] = oldCache;
            } else {
              result._selfGachaLevelGroups[i] = oldCache.update(current.gachaLevelGroups[i], null);
            }
          } else {
            result._selfGachaLevelGroups[i] = new GachaLevelGroup.WithParent(current.gachaLevelGroups[i], null);
          }
        }
      }
    }
    if (this._selfPromotionalGachaGroups) {
      if (this._value.promotionalGachaGroups === current.promotionalGachaGroups) {
        result._selfPromotionalGachaGroups = this._selfPromotionalGachaGroups;
      } else {
        result._selfPromotionalGachaGroups = [];
        for (let i = 0; i < current.promotionalGachaGroups.length; i++) {
          const oldValue = this._value.promotionalGachaGroups[i];
          if (oldValue) {
            const oldCache = this._selfPromotionalGachaGroups[i];
            if (oldValue === current.promotionalGachaGroups[i]) {
              result._selfPromotionalGachaGroups[i] = oldCache;
            } else {
              result._selfPromotionalGachaGroups[i] = oldCache.update(current.promotionalGachaGroups[i], null);
            }
          } else {
            result._selfPromotionalGachaGroups[i] = new PromotionalGachaGroup.WithParent(current.promotionalGachaGroups[i], null);
          }
        }
      }
    }
    return result;
  }
}
GachaConfig_WithParent.default = new GachaConfig_WithParent(GachaConfig.default, null);
GachaConfig.WithParent = GachaConfig_WithParent;
class GachaConfig_Descriptor {
  get gachaLevelGroups() {
    if (!this._gachaLevelGroups) {
      this._gachaLevelGroups = {
        name: "gachaLevelGroups",
        Name: "GachaLevelGroups",
        number: 3,
        protoType: 11,
        protoName: "gacha_level_groups",
        type: GachaLevelGroup,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._gachaLevelGroups;
  }
  get promotionalGachaGroups() {
    if (!this._promotionalGachaGroups) {
      this._promotionalGachaGroups = {
        name: "promotionalGachaGroups",
        Name: "PromotionalGachaGroups",
        number: 2,
        protoType: 11,
        protoName: "promotional_gacha_groups",
        type: PromotionalGachaGroup,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._promotionalGachaGroups;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.gachaLevelGroups,
        this.promotionalGachaGroups,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
GachaConfig.descriptor = new GachaConfig_Descriptor();
export class GachaStatus {
  get descriptor() {
    return GachaStatus.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._gachaGroupStatus = [];
    this._promotioinalGachaGroupStatus = [];
    this._hasCanDoTheFirstSpeicalSingleDraw = false;
    this._canDoTheFirstSpeicalSingleDraw = null;
  }
  isEmpty() {
    if (this._gachaGroupStatus.length > 0) return false;
    if (this._promotioinalGachaGroupStatus.length > 0) return false;
    if (this._hasCanDoTheFirstSpeicalSingleDraw) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof GachaStatus) {
      return value;
    }
    return GachaStatus.fromJson(value);
  }
  static fromJson(json) {
    const result = new GachaStatus();
    result._gachaGroupStatus = JsonToList(json.gachaGroupStatus, GachaGroupStatus);
    result._promotioinalGachaGroupStatus = JsonToList(json.promotioinalGachaGroupStatus, PromotionalGachaGroupStatus);
    if (json.canDoTheFirstSpeicalSingleDraw != null) {
      result._hasCanDoTheFirstSpeicalSingleDraw = true;
      result._canDoTheFirstSpeicalSingleDraw = JsonToBoolean.fromJson(json.canDoTheFirstSpeicalSingleDraw);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._gachaGroupStatus.length > 0) {
      result.gachaGroupStatus = ArrayToJson(this._gachaGroupStatus, GachaGroupStatus);
    }
    if (this._promotioinalGachaGroupStatus.length > 0) {
      result.promotioinalGachaGroupStatus = ArrayToJson(this._promotioinalGachaGroupStatus, PromotionalGachaGroupStatus);
    }
    if (this._hasCanDoTheFirstSpeicalSingleDraw) {
      result.canDoTheFirstSpeicalSingleDraw = JsonToBoolean.toJson(this._canDoTheFirstSpeicalSingleDraw);
    }
    return result;
  }
  /**
   * @returns {GachaGroupStatus[]}
   */
  get gachaGroupStatus() {
    return this._gachaGroupStatus;
  }
  addGachaGroupStatus(path, value) {
    return {type: 'ADD', path: path.concat(['gachaGroupStatus']), value: value.toJson()};
  }
  setGachaGroupStatus(path, value) {
    return {type: 'SET', path: path.concat(['gachaGroupStatus']), value: ArrayToJson(value, GachaGroupStatus)};
  }
  setGachaGroupStatusByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['gachaGroupStatus', key]), value: value.toJson()};
  }
  deleteGachaGroupStatus(path) {
    return {type: 'DELETE', path: path.concat(['gachaGroupStatus'])};
  }
  deleteGachaGroupStatusByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['gachaGroupStatus', key])};
  }
  /**
   * @returns {PromotionalGachaGroupStatus[]}
   */
  get promotioinalGachaGroupStatus() {
    return this._promotioinalGachaGroupStatus;
  }
  addPromotioinalGachaGroupStatus(path, value) {
    return {type: 'ADD', path: path.concat(['promotioinalGachaGroupStatus']), value: value.toJson()};
  }
  setPromotioinalGachaGroupStatus(path, value) {
    return {type: 'SET', path: path.concat(['promotioinalGachaGroupStatus']), value: ArrayToJson(value, PromotionalGachaGroupStatus)};
  }
  setPromotioinalGachaGroupStatusByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['promotioinalGachaGroupStatus', key]), value: value.toJson()};
  }
  deletePromotioinalGachaGroupStatus(path) {
    return {type: 'DELETE', path: path.concat(['promotioinalGachaGroupStatus'])};
  }
  deletePromotioinalGachaGroupStatusByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['promotioinalGachaGroupStatus', key])};
  }
  /**
   * @returns {boolean}
   */
  get canDoTheFirstSpeicalSingleDraw() {
    return this._hasCanDoTheFirstSpeicalSingleDraw ? this._canDoTheFirstSpeicalSingleDraw : JsonToBoolean.default;
  }
  get hasCanDoTheFirstSpeicalSingleDraw() {
    return this._hasCanDoTheFirstSpeicalSingleDraw;
  }
  setCanDoTheFirstSpeicalSingleDraw(path, value) {
    return {type: 'SET', path: path.concat(['canDoTheFirstSpeicalSingleDraw']), value};
  }
  deleteCanDoTheFirstSpeicalSingleDraw(path) {
    return {type: 'DELETE', path: path.concat(['canDoTheFirstSpeicalSingleDraw'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "gachaGroupStatus": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GachaStatus(this);
              copy._gachaGroupStatus = [];        for (let i of value) {
                copy._gachaGroupStatus.push(GachaGroupStatus.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new GachaStatus(this);
              copy._gachaGroupStatus = copy._gachaGroupStatus.concat([GachaGroupStatus.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._gachaGroupStatus.length === 0) {
                return this;
              }
              const copy = new GachaStatus(this);
              copy._gachaGroupStatus = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._gachaGroupStatus.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new GachaStatus(this);
              copy._gachaGroupStatus = copy._gachaGroupStatus.slice();
              copy._gachaGroupStatus[path[1]] = GachaGroupStatus.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new GachaStatus(this);
              copy._gachaGroupStatus = copy._gachaGroupStatus.slice(0, path[1]).concat(copy._gachaGroupStatus.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._gachaGroupStatus.length) {
            return this;
          }
          const oldValue = this._gachaGroupStatus[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new GachaStatus(this);
          copy._gachaGroupStatus = copy._gachaGroupStatus.slice();
          copy._gachaGroupStatus[key] = newValue;
          return copy;
        }
      }
      case "promotioinalGachaGroupStatus": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GachaStatus(this);
              copy._promotioinalGachaGroupStatus = [];        for (let i of value) {
                copy._promotioinalGachaGroupStatus.push(PromotionalGachaGroupStatus.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new GachaStatus(this);
              copy._promotioinalGachaGroupStatus = copy._promotioinalGachaGroupStatus.concat([PromotionalGachaGroupStatus.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._promotioinalGachaGroupStatus.length === 0) {
                return this;
              }
              const copy = new GachaStatus(this);
              copy._promotioinalGachaGroupStatus = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._promotioinalGachaGroupStatus.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new GachaStatus(this);
              copy._promotioinalGachaGroupStatus = copy._promotioinalGachaGroupStatus.slice();
              copy._promotioinalGachaGroupStatus[path[1]] = PromotionalGachaGroupStatus.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new GachaStatus(this);
              copy._promotioinalGachaGroupStatus = copy._promotioinalGachaGroupStatus.slice(0, path[1]).concat(copy._promotioinalGachaGroupStatus.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._promotioinalGachaGroupStatus.length) {
            return this;
          }
          const oldValue = this._promotioinalGachaGroupStatus[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new GachaStatus(this);
          copy._promotioinalGachaGroupStatus = copy._promotioinalGachaGroupStatus.slice();
          copy._promotioinalGachaGroupStatus[key] = newValue;
          return copy;
        }
      }
      case "canDoTheFirstSpeicalSingleDraw": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GachaStatus(this);
              copy._hasCanDoTheFirstSpeicalSingleDraw = true;
              copy._canDoTheFirstSpeicalSingleDraw = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCanDoTheFirstSpeicalSingleDraw) {
                return this;
              }
              const copy = new GachaStatus(this);
              copy._hasCanDoTheFirstSpeicalSingleDraw = false;
              copy._canDoTheFirstSpeicalSingleDraw = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {GachaStatus} other
   * @returns {GachaStatus}
   */
  merge(other) {
    const copy = new GachaStatus(this);
    copy._gachaGroupStatus = this._gachaGroupStatus.concat(other._gachaGroupStatus);
    copy._promotioinalGachaGroupStatus = this._promotioinalGachaGroupStatus.concat(other._promotioinalGachaGroupStatus);
    if (other._hasCanDoTheFirstSpeicalSingleDraw) {
      copy._hasCanDoTheFirstSpeicalSingleDraw = true;
      copy._canDoTheFirstSpeicalSingleDraw = other._canDoTheFirstSpeicalSingleDraw;
    }
    return copy;
  }
}
GachaStatus.default = new GachaStatus();
class GachaStatus_Builder {
  constructor(value) {
    this._value = new GachaStatus(value);
  }
  build() {
    return new GachaStatus(this._value);
  }
  addAllGachaGroupStatus(values) {
    this._value._gachaGroupStatus = this._value._gachaGroupStatus.concat(values);
    return this;
  }
  addGachaGroupStatus(value) {
    this._value._gachaGroupStatus = this._value._gachaGroupStatus.concat([value]);
    return this;
  }
  setGachaGroupStatus(index, value) {
    this._value._gachaGroupStatus = this._value._gachaGroupStatus.concat();
    this._value._gachaGroupStatus[index] = value;
    return this;
  }
  clearGachaGroupStatus() {
    this._value._gachaGroupStatus = [];
    return this;
  }
  addAllPromotioinalGachaGroupStatus(values) {
    this._value._promotioinalGachaGroupStatus = this._value._promotioinalGachaGroupStatus.concat(values);
    return this;
  }
  addPromotioinalGachaGroupStatus(value) {
    this._value._promotioinalGachaGroupStatus = this._value._promotioinalGachaGroupStatus.concat([value]);
    return this;
  }
  setPromotioinalGachaGroupStatus(index, value) {
    this._value._promotioinalGachaGroupStatus = this._value._promotioinalGachaGroupStatus.concat();
    this._value._promotioinalGachaGroupStatus[index] = value;
    return this;
  }
  clearPromotioinalGachaGroupStatus() {
    this._value._promotioinalGachaGroupStatus = [];
    return this;
  }
  setCanDoTheFirstSpeicalSingleDraw(value) {
    this._value._hasCanDoTheFirstSpeicalSingleDraw = true;
    this._value._canDoTheFirstSpeicalSingleDraw = value;
    return this;
  }
  deleteCanDoTheFirstSpeicalSingleDraw() {
    this._value._hasCanDoTheFirstSpeicalSingleDraw = false;
    this._value._canDoTheFirstSpeicalSingleDraw = null;
    return this;
  }
}
GachaStatus.Builder = GachaStatus_Builder;
class GachaStatus_WithParent {
  /**
   * @param {GachaStatus} value
   * @param {GachaStatus_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return GachaStatus.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfGachaGroupStatus() {
    if (!this._selfGachaGroupStatus) {
      this._selfGachaGroupStatus = [];
      for (let i of this._value.gachaGroupStatus) {
        this._selfGachaGroupStatus.push(new GachaGroupStatus.WithParent(i, null));
      }
    }
    return this._selfGachaGroupStatus;
  }
  get inherentGachaGroupStatus() {
    if (!this._inherentGachaGroupStatus) {
      this._inherentGachaGroupStatus = this._parent ? this._parent.gachaGroupStatus : [];
    }
    return this._inherentGachaGroupStatus;
  }
  get gachaGroupStatus() {
    if (!this._allGachaGroupStatus) {
      this._allGachaGroupStatus = this._parent ? this._parent.gachaGroupStatus.concat(this.selfGachaGroupStatus) : this.selfGachaGroupStatus;
    }
    return this._allGachaGroupStatus;
  }
  get selfPromotioinalGachaGroupStatus() {
    if (!this._selfPromotioinalGachaGroupStatus) {
      this._selfPromotioinalGachaGroupStatus = [];
      for (let i of this._value.promotioinalGachaGroupStatus) {
        this._selfPromotioinalGachaGroupStatus.push(new PromotionalGachaGroupStatus.WithParent(i, null));
      }
    }
    return this._selfPromotioinalGachaGroupStatus;
  }
  get inherentPromotioinalGachaGroupStatus() {
    if (!this._inherentPromotioinalGachaGroupStatus) {
      this._inherentPromotioinalGachaGroupStatus = this._parent ? this._parent.promotioinalGachaGroupStatus : [];
    }
    return this._inherentPromotioinalGachaGroupStatus;
  }
  get promotioinalGachaGroupStatus() {
    if (!this._allPromotioinalGachaGroupStatus) {
      this._allPromotioinalGachaGroupStatus = this._parent ? this._parent.promotioinalGachaGroupStatus.concat(this.selfPromotioinalGachaGroupStatus) : this.selfPromotioinalGachaGroupStatus;
    }
    return this._allPromotioinalGachaGroupStatus;
  }
  get hasCanDoTheFirstSpeicalSingleDraw() {
    if (this._cachedHasCanDoTheFirstSpeicalSingleDraw === undefined) {
      if (this._value.hasCanDoTheFirstSpeicalSingleDraw) {
        this._cachedHasCanDoTheFirstSpeicalSingleDraw = true;
      } else {
        this._cachedHasCanDoTheFirstSpeicalSingleDraw = this._parent ? this._parent.hasCanDoTheFirstSpeicalSingleDraw : false;
      }
    }
    return this._cachedHasCanDoTheFirstSpeicalSingleDraw;
  }
  get canDoTheFirstSpeicalSingleDraw() {
    if (this._cachedCanDoTheFirstSpeicalSingleDraw === undefined) {
      if (this._value.hasCanDoTheFirstSpeicalSingleDraw) {
        this._cachedCanDoTheFirstSpeicalSingleDraw = this._value.canDoTheFirstSpeicalSingleDraw;
      } else {
        this._cachedCanDoTheFirstSpeicalSingleDraw = this._parent ? this._parent.canDoTheFirstSpeicalSingleDraw : this._value.canDoTheFirstSpeicalSingleDraw;
      }
    }
    return this._cachedCanDoTheFirstSpeicalSingleDraw;
  }
  update(current, parent) {
    const result = new GachaStatus_WithParent(current, parent);
    if (this._selfGachaGroupStatus) {
      if (this._value.gachaGroupStatus === current.gachaGroupStatus) {
        result._selfGachaGroupStatus = this._selfGachaGroupStatus;
      } else {
        result._selfGachaGroupStatus = [];
        for (let i = 0; i < current.gachaGroupStatus.length; i++) {
          const oldValue = this._value.gachaGroupStatus[i];
          if (oldValue) {
            const oldCache = this._selfGachaGroupStatus[i];
            if (oldValue === current.gachaGroupStatus[i]) {
              result._selfGachaGroupStatus[i] = oldCache;
            } else {
              result._selfGachaGroupStatus[i] = oldCache.update(current.gachaGroupStatus[i], null);
            }
          } else {
            result._selfGachaGroupStatus[i] = new GachaGroupStatus.WithParent(current.gachaGroupStatus[i], null);
          }
        }
      }
    }
    if (this._selfPromotioinalGachaGroupStatus) {
      if (this._value.promotioinalGachaGroupStatus === current.promotioinalGachaGroupStatus) {
        result._selfPromotioinalGachaGroupStatus = this._selfPromotioinalGachaGroupStatus;
      } else {
        result._selfPromotioinalGachaGroupStatus = [];
        for (let i = 0; i < current.promotioinalGachaGroupStatus.length; i++) {
          const oldValue = this._value.promotioinalGachaGroupStatus[i];
          if (oldValue) {
            const oldCache = this._selfPromotioinalGachaGroupStatus[i];
            if (oldValue === current.promotioinalGachaGroupStatus[i]) {
              result._selfPromotioinalGachaGroupStatus[i] = oldCache;
            } else {
              result._selfPromotioinalGachaGroupStatus[i] = oldCache.update(current.promotioinalGachaGroupStatus[i], null);
            }
          } else {
            result._selfPromotioinalGachaGroupStatus[i] = new PromotionalGachaGroupStatus.WithParent(current.promotioinalGachaGroupStatus[i], null);
          }
        }
      }
    }
    return result;
  }
}
GachaStatus_WithParent.default = new GachaStatus_WithParent(GachaStatus.default, null);
GachaStatus.WithParent = GachaStatus_WithParent;
class GachaStatus_Descriptor {
  get gachaGroupStatus() {
    if (!this._gachaGroupStatus) {
      this._gachaGroupStatus = {
        name: "gachaGroupStatus",
        Name: "GachaGroupStatus",
        number: 2,
        protoType: 11,
        protoName: "gacha_group_status",
        type: GachaGroupStatus,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._gachaGroupStatus;
  }
  get promotioinalGachaGroupStatus() {
    if (!this._promotioinalGachaGroupStatus) {
      this._promotioinalGachaGroupStatus = {
        name: "promotioinalGachaGroupStatus",
        Name: "PromotioinalGachaGroupStatus",
        number: 3,
        protoType: 11,
        protoName: "promotioinal_gacha_group_status",
        type: PromotionalGachaGroupStatus,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._promotioinalGachaGroupStatus;
  }
  get canDoTheFirstSpeicalSingleDraw() {
    if (!this._canDoTheFirstSpeicalSingleDraw) {
      this._canDoTheFirstSpeicalSingleDraw = {
        name: "canDoTheFirstSpeicalSingleDraw",
        Name: "CanDoTheFirstSpeicalSingleDraw",
        number: 4,
        protoType: 8,
        protoName: "can_do_the_first_speical_single_draw",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._canDoTheFirstSpeicalSingleDraw;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.gachaGroupStatus,
        this.promotioinalGachaGroupStatus,
        this.canDoTheFirstSpeicalSingleDraw,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCanDoTheFirstSpeicalSingleDraw",
        Name: "DummyOneofForCanDoTheFirstSpeicalSingleDraw",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
GachaStatus.descriptor = new GachaStatus_Descriptor();
